var Boxfox = (function(){

	// Modal module
	var Modal = {};

	Modal.queue = [];

	Modal.element = null;

	Modal.show = function() {
		// Do we have an active modal?
		// If so, lets wait our turn
		if (Modal.element != null) {
			return false;
		}

		// Do we have any requests in the queue?
		// If not, lets just wait until we have some to show
		if (Modal.queue.length == 0) {
			return false;
		}

		// If we've reached this far that means we're first in line
		// You may proceed with the dialog
		var modal = $(Modal.queue.shift());

		// Add modal type-specific event handling
		if (modal.data('type') == 'alert') {
			var callback, confirmCallback;

			callback = modal.data('callback');

			confirmCallback = function(e) {
				Modal.hide();
				callback(true);
				e.preventDefault();
			};

			// Click events
			modal.find('button[data-action="confirm"]').on('click', confirmCallback);

			// Keyboard events
			$(document).on('keydown.app-modal', function(e) {
				// Enter key
				if(e.which == 13) { confirmCallback(e); }
			});
		}

		if (modal.data('type') == 'confirmation') {
			var callback, confirmCallback, cancelCallback;

			callback = modal.data('callback');

			confirmCallback = function(e) {
				Modal.hide();
				callback(true);
				e.preventDefault();
			};

			cancelCallback = function(e) {
				Modal.hide();
				callback(false);
				e.preventDefault();
			};

			// Click events
			modal.find('button[data-action="confirm"]').on('click', confirmCallback);
			modal.find('button[data-action="cancel"]').on('click', cancelCallback);

			// Keyboard events
			$(document).on('keydown.app-modal', function(e) {
				// Enter key
				if(e.which == 13) { confirmCallback(e); }

				// Escape key
				if(e.which == 27) { cancelCallback(e); }
			});
		}

		if (modal.data('type') == 'window') {
			var buttons, header, content, footer, iframe, updateDialog;

			// Define modal properties
			buttons = modal.data('buttons');

			// Define DOM elements
			header = modal.find('.modal-dialog-header');
			content = modal.find('.modal-dialog-content');
			footer =  modal.find('.modal-dialog-actions');
			iframe = modal.find('iframe');

			// Define helper methods
			updateDialog = function() {
        var max_height, modal_height, header_height, footer_height, iframe_height;

        iframe.css('height', 'auto');

        // Force css reset before measuring native iframe height
        setTimeout(function() {
            modal_height = modal.height();
            header_height = header.outerHeight();
            footer_height = footer.outerHeight();
            iframe_height = iframe.contents().outerHeight();

            max_height = modal_height - header_height - footer_height;
            iframe_height = (iframe_height < max_height) ? iframe_height : max_height;

            content.css('max-height', max_height + 'px');
            iframe.css('height', iframe_height + 'px');
        }, 0);
	    };

			for (var i = 0; i < buttons.length; i++) {
				var button, callback, el, fn;

				button = buttons[i];
				callback = button.callback || function() {};
				el = modal.find('[data-action="callback-' + i + '"]');

				fn = function(e) {
					Modal.hide();
					callback(true);
					e.preventDefault();
				}

				el.on('click', fn);
			}

			// Event handling
			iframe.on('load', updateDialog);
	    $(window).on('resize.app-modal', updateDialog);
		}

		if (modal.data('type') == 'content') {
			var title, buttons, header, footer;

			// Define modal properties
			title = modal.data('title');
			buttons = modal.data('buttons');

			// Define DOM elements
			header = modal.find('.modal-dialog-header');
			footer =  modal.find('.modal-dialog-actions');

			for (var i = 0; i < buttons.length; i++) {
				var button, callback, el, fn;

				button = buttons[i];
				callback = button.callback || function() {};
				el = modal.find('[data-action="callback-' + i + '"]');

				fn = function(e) {
					Modal.hide();
					callback(true);
					e.preventDefault();
				}

				el.on('click', fn);
			}

			if (title.length === 0) { header.hide(); }
			if (buttons.length === 0) { footer.hide(); }
		}

		if (modal.data('type') == 'page' || modal.data('type') == 'mini-page') {
			var backCallback, stopPropagation;

			backCallback = function(e) {
				Modal.hide();
				e.preventDefault();
			};

			stopPropagation = function(e) {
				e.stopImmediatePropagation();
			}

			// Click events
			modal.find('button[data-action="back"]').on('click', backCallback);
			modal.find('.modal-dialog-content').on('click', stopPropagation);
			modal.on('click.app-modal', Modal.hide);

			// Keyboard events
			$(document).on('keydown.app-modal', function(e) {
				// Left arrow key
				if(e.which == 37) { backCallback(e); }

				// Escape key
				if(e.which == 27) { backCallback(e); }
			});
		}

		// Add modal to DOM
		$('html').addClass('has-modal');

		modal.appendTo('body');
		setTimeout(function(){ modal.addClass('visible'); }, 0);

		// Update Modal object
		Modal.element = modal;

		// Call the onload method yo!
		if (modal.data('onload')) {
			modal.data('onload').call();
		}


		return modal;
	};

	Modal.hide = function() {
		if (typeof Modal.element == 'undefined') {
			return false;
		}

		var delay, modal;

		delay = 500;
		modal = $(Modal.element);

		$('html').removeClass('has-modal');
		$(window).off('.app-modal');
		$(document).off('.app-modal');

		modal.removeClass('visible');
		setTimeout(function(){
			// Remove modal from DOM
			modal.remove();

			// Clear Modal object
			Modal.element = null;

			// Request next modal in queue
			Modal.show();
		}, delay);

		return modal;
	}

	Modal.alert = function(options, fn) {
		var source, template, modal;

		// Set defaults
		this.options = {
			title: "Alert!",
			message: "This is an alert message",
			confirmButton: "Okay"
		};

		fn = fn || function(){};

		// Extend with user defined options
		$.extend(this.options, options);

		// Get template
		source = $('#boxfox-app-modal-alert').html().trim();
		template = Handlebars.compile(source);

		// Construct modal object
		modal = $(template(this.options));

		// Extend modal object with type and callback
		modal.data('type', 'alert');
		modal.data('callback', fn);

		// Add our modal to the queue
		Modal.queue.push(modal);

		// Request to be shown
		Modal.show();
	};

	Modal.confirm = function(options, fn) {
		var source, template, modal;

		// Set defaults
		this.options = {
			title: "Confirmation!",
			message: "This is a confirmation message",
			confirmButton: "Okay",
			cancelButton: "Cancel",
			style: ''
		};

		fn = fn || function(){};

		// Extend with user defined options
		$.extend(this.options, options);

		// Get template
		source = $('#boxfox-app-modal-confirmation').html().trim();
		template = Handlebars.compile(source);

		// Construct modal object
		modal = $(template(this.options));

		// Extend modal object with type and callback
		modal.data('type', 'confirmation');
		modal.data('callback', fn);

		// Add our modal to the queue
		Modal.queue.push(modal);

		// Request to be shown
		Modal.show();
	};

	Modal.content = function(options) {
		var source, template, modal;

		// Set defaults
		this.options = {
			title: "",
			content: "",
			buttons: []
		};

		// Extend with user defined options
		$.extend(this.options, options);

		// Get template
		source = $('#boxfox-app-modal-content').html().trim();
		template = Handlebars.compile(source);

		// Construct modal object
		modal = $(template(this.options));

		// Extend modal object with type, title, and buttons
		modal.data('type', 'content');
		modal.data('title', this.options.title);
		modal.data('buttons', this.options.buttons);

		// Add our modal to the queue
		Modal.queue.push(modal);

		// Request to be shown
		Modal.show();
	}

	Modal.window = function(options) {
		var source, template, modal;

		// Set defaults
		this.options = {
			title: "",
			src: "",
			buttons: [
				{
					label: "Done"
				}
			]
		};

		// Extend with user defined options
		$.extend(this.options, options);

		// Get template
		source = $('#boxfox-app-modal-window').html().trim();
		template = Handlebars.compile(source);

		// Construct modal object
		modal = $(template(this.options));

		// Extend modal object with type and buttons
		modal.data('type', 'window');
		modal.data('buttons', this.options.buttons);

		// Add our modal to the queue
		Modal.queue.push(modal);

		// Request to be shown
		Modal.show();
	}

	Modal.page = function(options) {
		var source, template, modal;

		// Set defaults
		this.options = {
			content: "",
			backButton: "Back",
			onload: function() {}
		};

		// Extend with user defined options
		$.extend(this.options, options);

		// Get template
		source = $('#boxfox-app-modal-page').html().trim();
		template = Handlebars.compile(source);

		// Construct modal object
		modal = $(template(this.options));

		// Extend modal object with type
		modal.data('type', 'page');
		modal.data('onload', this.options.onload);

		// Add our modal to the queue
		Modal.queue.push(modal);

		// Request to be shown
		Modal.show();
	}

	Modal.miniPage = function(options) {
		var source, template, modal;

		// Set defaults
		this.options = {
			content: "",
			backButton: "Back",
			onload: function() {}
		};

		// Extend with user defined options
		$.extend(this.options, options);

		// Get template
		source = $('#boxfox-app-modal-mini-page').html().trim();
		template = Handlebars.compile(source);

		// Construct modal object
		modal = $(template(this.options));

		// Extend modal object with type
		modal.data('type', 'page');
		modal.data('onload', this.options.onload);

		// Add our modal to the queue
		Modal.queue.push(modal);

		// Request to be shown
		Modal.show();
	}

	// Notification module
	var Notification = {};

	Notification.element = null;

	Notification.show = function(el) {
		if (typeof el == 'undefined') {
			return false;
		}

		var delay, notification;

		delay = 2000;
		notification = $(el);

		// Add notification to DOM
		$('html').addClass('has-notification');

		notification.appendTo('body');
		setTimeout(function(){ notification.addClass('visible'); }, 0);

		// Reset flash timer
		clearTimeout(window.flashNoticeTimer);
		window.flashNoticeTimer = setTimeout(Notification.hide, delay);

		// Update Notification object
		Notification.element = el;

		return el;
	};

	Notification.update = function(el) {
		if (typeof el == 'undefined') {
			return false;
		}

		var delay, notification;

		delay = 2000;
		notification = $(el);

		// Replace the notification
		$(Notification.element).replaceWith(notification.addClass('visible'));

		// Reset flash timer
		clearTimeout(window.flashNoticeTimer);
		window.flashNoticeTimer = setTimeout(Notification.hide, delay);

		// Update notification object
		Notification.element = el;

		return el;
	}

	Notification.hide = function() {
		if (typeof Notification.element == 'undefined') {
			return false;
		}

		var delay, notification;

		delay = 500;
		notification = $(Notification.element);

		$('html').removeClass('has-notification');
		$(window).off('.app-notification');
		$(document).off('.app-notification');

		notification.removeClass('visible');
		setTimeout(function(){ notification.remove(); }, delay);

		// Clear outstanding timers
		clearTimeout(window.flashNoticeTimer);

		// Clear Notification object
		Notification.element = null;

		return notification;
	}

	var flashNotice = function(options) {
		var source, template, html, notification, closeButton, dismissNotification;

		// Set defaults
		this.options = {
			style: "default",
			message: "This is an notification!"
		};

		// Extend with user defined options
		$.extend(this.options, options);

		// Get template
		source = $('#boxfox-app-flash-notification').html().trim();
		template = Handlebars.compile(source);

		// Construct HTML
		html = $(template(this.options));

		// Define DOM elements
		notification = html;
		closeButton = html.find('[data-action="close"]');

		// Bind object & events
		//Notification.element = notification;
		dismissNotification = function(e) {
			Notification.hide();
			e.preventDefault();
		};

		closeButton.on('click', dismissNotification);

		// Repaint UI
		if (Notification.element != null) {
			Notification.update(notification);
		} else {
			Notification.show(notification);
		}
	}

	// Navigation module
	var Navigation = {};

	Navigation.queue = [];

	Navigation.pageIndex = 0;
	Navigation.trackWidth = 0;
	Navigation.trackMinHeight = 0;

	Navigation.widget = $('.boxfox-pages');
	Navigation.track = $('.boxfox-page-track', Navigation.widget);
	Navigation.slides = $('.boxfox-page', Navigation.track);
	Navigation.buttons = $('[data-page-num],[data-page-action]', Navigation.widget);

	Navigation.goToPageIndex = function(n) {
		var pages = $('.boxfox-page', Navigation.track);

		// Set page index
		Navigation.pageIndex = (typeof n != 'undefined') ? n : Navigation.pageIndex;

		// Animate to page
		Navigation.track.css({
			transition: 'transform 500ms ease',
			transform: 'translate3d(-' + (Navigation.pageIndex * Navigation.trackWidth) + 'px, 0, 0)',
			//height: 'auto'
			//height: Math.max(Navigation.trackMinHeight, pages.eq(Navigation.pageIndex).height())
		});

		// Hide pages
		pages.removeClass('active');

		// Show current page
		pages.eq(Navigation.pageIndex).addClass('active');

		// Scroll to top
		$('html, body').scrollTop(0);
	};

	Navigation.nextPage = function() {
		var pages = $('.boxfox-page', Navigation.track), i;

		i = ((Navigation.pageIndex + 1) >= pages.length) ? (pages.length - 1) : (Navigation.pageIndex + 1);
		Navigation.goToPageIndex(i);
	}

	Navigation.prevPage = function() {
		var pages = $('.boxfox-page', Navigation.track), i;

		i = ((Navigation.pageIndex - 1) <= 0) ? 0 : (Navigation.pageIndex - 1);
		Navigation.goToPageIndex(i);
	}

	Navigation.layout = function() {
		var pages = $('.boxfox-page', Navigation.track);

		// Define width
		Navigation.track.width('auto');
		Navigation.trackWidth = Navigation.track.width();

		// Update page widths
		pages.width(Navigation.trackWidth);

		// Update track width
		Navigation.track.width(Navigation.trackWidth * pages.length);

		// Define page height
		Navigation.track.height('auto');
		Navigation.trackMinHeight = $(window).height();

		// Update track position
		Navigation.track.css({
			transition: 'none',
			transform: 'translate3d(-' + (Navigation.pageIndex * Navigation.trackWidth) + 'px, 0, 0)',
			//height: Math.max(Navigation.trackMinHeight, pages.eq(Navigation.pageIndex).height())
		});
	}

	Navigation.init = function() {
		// Update page queue
		Navigation.slides.each(function(){
			Navigation.queue.push($(this));
		});

		// bind events
		$(window).on('load resize', Navigation.layout);
		Navigation.buttons.on('click', function(e) {
			// Convert page actions & numbers to indexes
			var button, index;

			button = $(this);
			index = button.attr('data-page-action') ? Navigation.pageIndex : button.attr('data-page-num');

			if (button.attr('data-page-action') == 'next') {
				index += 1;
			}
			if (button.attr('data-page-action') == 'prev') {
				index -= 1;
			}
			if (button.attr('data-page-num')) {
				index -= 1;
			}

			Navigation.goToPageIndex(index);
			e.preventDefault();
		});

		return Navigation;
	};

	Navigation.loadView = function(view) {
		// Do we have an element to work with?
		// If not, lets wait until we do
		if (typeof view == 'undefined') {
			return false;
		}

		// Add our view to the queue
		Navigation.queue.push(view);

		// Add view type-specific event handling
		if (view.data('type') == 'page') {
			var title, callback;

			title = view.data('title');
			callback = view.data('callback');

			// Update the current page title
			document.title = title;

			// Bind callback to custom 'show' event
			view.on('show',  callback);
		}

		// Add view to DOM
		view.appendTo(Navigation.track);

		// Update page layout
		Navigation.layout();

		// Update pageIndex and go to new view...
		Navigation.pageIndex = (Navigation.queue.length - 1);
		Navigation.goToPageIndex(Navigation.pageIndex);

		// Trigger 'show' event
		view.trigger('show');

		return view;
	};

	Navigation.page = function(options, fn) {
		var source, template, view;

		// Set defaults
		this.options = {
			title: "",
			content: ""
		};

		fn = fn || function(){};

		// Extend with user defined options
		$.extend(this.options, options);

		// Get template
		source = $('#boxfox-app-navigation-page').html().trim();
		template = Handlebars.compile(source);

		// Construct page object
		view = $(template(this.options));

		// Extend view object with type and callback
		view.data('type', 'page');
		view.data('title', this.options.title);
		view.data('callback', fn);

		// Request to be shown
		Navigation.loadView(view);
	};

	// Build module
	var Build = {};

	Build.getParameterByName = function(name) {
		var regex, results;

		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
		regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
		results = regex.exec(location.search);

		return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	}

	Build.hasHashTag = function() {
		return window.location.hash.length;
	}

	Build.decodeEntities = function(str) {
		var element = document.createElement('div');

		if(str && typeof str === 'string') {
			// strip script/html tags
			str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
			str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
			element.innerHTML = str;
			str = element.textContent;
			element.textContent = '';
		}

		return str;
	}

	Build.itemByID = function(id) {
		var o;

		$.each(Build.items, function(index, obj) {
			if (obj.id == id) {
				o = obj;
			}
		});

		return o;
	}

	Build.objectFromElement = function(el) {
		var o;

		$.each(Build.items, function(index, obj) {
			if (el.prop('id') == obj.id) {
				o = obj;
			}
		});

		return o;
	};

	Build.itemInBox = function(obj) {
		for (var i = 0; i < Build.box.items.length; i++) {
			if (Build.box.items[i]['id'] === obj['id']) {
				return Build.box.items[i];
			}
		}

		return false;
	};

	Build.itemQuantityInBox = function(obj) {
		var quantity = 0;

		for (var i = 0; i < Build.box.items.length; i++) {
			if (Build.box.items[i]['id'] === obj['id']) {
				quantity = Build.box.items[i].quantity;
				break;
			}
		}

		return quantity;
	};

	Build.itemIsAvailable = function(obj) {
		var item;

		$.each(Build.items, function(index, o) {
			if (o.id == obj.id) {
				item = obj;
			}
		});

		if (typeof item == 'undefined' || item.available == false) {
			return false;
		} else {
			return true;
		}
	};

	Build.addItem = function(obj) {
		obj.quantity = 1;

		// Push on to items array
		Build.box.items.push(obj);

		// Add to box contents & tray
		Build.updateItemListUI(obj);
		Build.updateItemBoxUI(obj);
		Build.updateItemTrayUI(obj);
	};

	Build.removeItem = function(obj) {
		$('.box-images li[id="' + obj.id + '"]').remove();
		$('.list-items li[id="' + obj.id + '"]').remove();

		if (Build.itemInBox(obj)) {
			for (var i = 0; i < Build.box.items.length; i++) {
				if (Build.box.items[i]['id'] == obj['id']) {
					Build.box.items.splice(i, 1);
				}
			}
		}
	};

	Build.increaseItem = function(e) {
		var button, id, obj, item;

		button = $(this);
		id = button.attr('data-id');
		obj = Build.itemByID(id);
		item = Build.itemInBox(obj);

		if (button.data('item-size') > Build.box.remaining_size) {
			Boxfox.Modal.alert({
				title: "Too Large",
				message: "It looks like this item is too large to fit in your box.",
				confirmButton: "Okay",
			});
			return
		}

		if (item) {
			item.quantity += 1;
			Build.updateItemListUI(item);
			Build.updateItemBoxUI(item);
			Build.updateItemTrayUI(item);
			Build.updateItemBuyButtonsUI(item);
		} else {
			Build.addItem(obj);
			Build.updateItemBuyButtonsUI(obj);
		}

		Boxfox.flashNotice({
			message: obj.title + " added to your box"
		});

		Build.updateBox();

		if (typeof e != 'undefined') e.preventDefault();
	};

	Build.decreaseItem = function(e) {
		var button, id, obj, item;

		button = $(this);
		id = $(this).attr('data-id');
		obj = Build.itemByID(id);
		item = Build.itemInBox(obj);

		if (button.hasClass('disabled')) {
			return;
		}

		if (item) {
			item.quantity -= 1;

			if (item.quantity === 0) {
				Build.removeItem(item);
			} else {
				Build.updateItemListUI(item);
				Build.updateItemBoxUI(item);
				Build.updateItemTrayUI(item);
			}

			Build.updateItemBuyButtonsUI(item);

			Boxfox.flashNotice({
				message: obj.title + " removed to your box"
			});

			Build.updateBox();
		}

		if (typeof e != 'undefined') e.preventDefault();
	};

	Build.showItemInfo = function(e) {
		var item, id, obj;

		item = $(this);
		id = item.attr('data-id');
		obj = Build.itemByID(id);

		// Get template
		var source, template, html;

		source = $('#modal-product-template').html();
		template = Handlebars.compile(source);
		html = template(obj);

		var onload = function() {
			// Init photo slider
			var slider = $('.modal-product__images .product__slides');

			slider.slick({
				adaptiveHeight: true,
				dots: true,
				swipe: true,
				appendDots: $('.modal-product__images .product__thumbs'),
				customPaging: function(slider, i) {
					var thumb = $(slider.$slides[i]).data('thumb');
					return '<img src="'+thumb+'">';
				}
			});

			$('.modal-product .boxfox-buy-buttons button[data-action="increase"]').on('click', Build.increaseItem);
			$('.modal-product .boxfox-buy-buttons button[data-action="decrease"]').on('click', Build.decreaseItem);
			$('.modal-product .boxfox-favorite').on('click', Build.toggleFavorite);
			$('.modal-product__images img').imagesLoaded(function(){
				slider.slick('setPosition');
			});
		}

		Boxfox.Modal.page({
			content: html,
			onload: onload
		});

		if (typeof e != 'undefined') e.preventDefault();
	}

	Build.updateItemListUI = function(obj) {
		var source, template, html, el;

		source = $('#list-item-template').html();
		template = Handlebars.compile(source);

		Handlebars.registerHelper('formatMoney', function(price) {
			return '$' + (price / 100).toFixed(2);
		});

		html = template(obj);

		el = $('.custom-box-list-wrapper .list-items li[id="' + obj.id + '"]');

		if (el.length) {
			el.replaceWith(html);
		} else {
			$('.custom-box-list-wrapper .list-items').append(html);
		}
	};

	Build.updateItemBoxUI = function(obj) {
		var source, template, html, el;

		source = $('#box-item-template').html();
		template = Handlebars.compile(source);
		html = template(obj);

		el = $('.custom-box-contents .box-images li[id="' + obj.id + '"]');

		if (el.length) {
			el.replaceWith(html);
		} else {
			$('.custom-box-contents .box-images').append(html);
		}

		Build.boxImages.sortable('refresh');
	};

	Build.updateItemTrayUI = function(obj) {
		var source, template, html, el;

		source = $('#box-item-template').html();
		template = Handlebars.compile(source);
		html = template(obj);

		el = $('.custom-box-tray-items .box-images li[id="' + obj.id + '"]');

		if (el.length) {
			el.replaceWith(html);
		} else {
			$('.custom-box-tray-items .box-images').append(html);
		}
	};

	Build.updateItemBuyButtonsUI = function(obj) {
		var component, quantity;

		component = $('.boxfox-buy-buttons[data-id="'+ obj.id +'"]');
		quantity = $('.label .quantity', component);

		if (obj.quantity > 0) {
			component.addClass('in-cart');
		} else {
			component.removeClass('in-cart');
		}

		quantity.html(obj.quantity);
	}

	Build.updateBox = function() {
		// Update box size, variant, price
		Build.manageBoxSize();

		// Toggle instructions
		if (Build.box.items.length == 0) {
			$('.custom-box-images-wrapper .instructions').show();
			$('.custom-box-images-wrapper .building-box').hide();
			$('.custom-box-list-wrapper .list-items li[id]').remove();
			$('.custom-box-images-wrapper .box-images li[id]').remove();
			$('.custom-box-tray-items .box-images li[id]').remove();
			$('.boxfox-buy-buttons').removeClass('in-cart');
			$('#custom-box-tray').removeClass('visible');

			$('#card-options .card-options').show();
			$('#card-options .card-message').hide();
			$('#message').val('');
			$('#card-options input[name="card-outside"]').attr('checked', false);
			$('#card-options .card-image').attr('src', '');
		} else {
			$('.custom-box-images-wrapper .instructions').hide();
			$('.custom-box-images-wrapper .building-box').hide();
			$('#custom-box-tray').addClass('visible');
		}

		// Toggle favorites
		if (Build.favorites.length) {
			$('#boxfox-favorites').addClass('visible');
		} else {
			$('#boxfox-favorites').removeClass('visible');
		}

		// Toggle buy buttons
		$('.boxfox-buy-buttons button[data-action="increase"]').each(function() {
			var item = $(this);

			if (item.data('item-size') > Build.box.remaining_size) {
				item.attr('disabled', true).addClass('disabled');
			} else {
				item.attr('disabled', false).removeClass('disabled');
			}
		});

		// Toggle available items
		$('.box-items .box-item').each(function() {
			var item = $(this);

			// Item is available
			if (item.attr('data-item-size') > Build.box.remaining_size) {
				item.addClass('disabled');
				item.find('.plus').addClass('disabled');
			} else {
				item.removeClass('disabled');
				item.find('.plus').removeClass('disabled');
			}

			// Item is sold out
			if (item.attr('data-item-available') == 'false') {
				item.find('.plus').addClass('disabled');
				item.find('.minus').addClass('disabled');
			}
		});

		// Update box price
		$('.base-price').html('$' + (Build.box.base_price / 100).toFixed(2));

		// Update subtotal
		$('.subtotal').html('$' + (Build.box.price / 100).toFixed(2));

		// Update box size labels
		$('.box-size').html(Build.box.box_size);

		// Update box color
		var el = $('.box-color-options-list a[data-box-color="' + Build.box.color + '"]');

		$('.box-color-options-list a').removeClass('selected');
		el.addClass('selected');

		$('.box-color').attr('src', Build.box.image);

		// Update selected card
		var el = $('.card-options-list a[data-card-title="' + Build.box.card + '"]');

		$('.card-options-list a').removeClass('selected');
		el.addClass('selected');

		$('.card-image').attr('src', el.attr('data-card-image'));

		if (Build.box.card != '') {
			$('#card-options .card-options').hide();
			$('#card-options .card-message').show();
		}

		// Update card message and location
		if (Build.box.card_location == 'Outside') {
			$('#message').attr('disabled', true).val(Build.box.message);
			$('.custom-box-message').addClass('no-message').html('(blank)');
			$('#card-options input[name="card-outside"]').attr('checked', true);
		} else {
			$('#message').attr('disabled', false).val(Build.box.message);
			$('.custom-box-message').removeClass('no-message').html(Build.box.message);
			$('#card-options input[name="card-outside"]').attr('checked', false);
		}

		// Update remaining character count
		Build.remainingCharacters();

		// Update confirmation page
		if (Build.box.status == 'incomplete') {
			Build.resetBoxComplete();
		} else {
			Build.updateBoxComplete();
		}

		// Update local storage
		if (localStorage) {
			localStorage.setItem('custom-box', JSON.stringify(Build.box));
		}
	};

	Build.rebuildBox = function() {
		var i = Build.box.items.length;
		while (i--) {
			var obj = Build.box.items[i];

			// Remove unavailable items
			if (!Build.itemIsAvailable(obj)) {
				Build.removeItem(obj);
				continue;
			}

			// Update user interface
			Build.updateItemListUI(obj);
			Build.updateItemBoxUI(obj);
			Build.updateItemTrayUI(obj);
			Build.updateItemBuyButtonsUI(obj);

			// Buttons
			$('.box-items li[id="' + obj.id + '"] .minus').removeClass('disabled');
		}

		var i = Build.favorites.length;
		while (i--) {
			// Grab object with same id as in favorites array
			var item = Build.itemByID(Build.favorites[i].id);

			if (item) {
				// Update favorites to use object (allows us to use indexOf with object)
				Build.favorites[i] = item;

				// Update UI
				$('.boxfox-favorite[data-id="' + item.id + '"]').addClass('saved');
			} else {
				// Remove item from favorites
				Build.favorites.splice(i, 1);
			}
		}

		Build.updateBox();
	};

	Build.resetBox = function() {
		window.localStorage.clear();
		window.location = window.location.pathname;
	}

	Build.continueShopping = function() {
		Build.box = $.extend({}, Build.default_box);
		Build.updateBox();
		Build.goToStep(1);
	};

	Build.validateItems = function(e) {
		if (Build.box.items.length == 0) {
			Boxfox.Modal.alert({
				title: "Your Box is Empty",
				message: 'It looks like you haven\'t added anything to your box. Please add at least one item before proceeding.',
				confirmButton: "Okay",
			});
		} else {
			Build.goToStep(3);
		}

		if (typeof e != 'undefined') e.preventDefault();
	}

	Build.selectBoxColor = function(e) {
		var el, color, available;

		el = $(this);
		color = el.attr('data-box-color');
		available = el.attr('data-available');

		$('.box-color-options-list a').removeClass('selected');
		el.addClass('selected');

		Build.box.color = color;
		Build.updateBox();
		Build.goToStep(2);

		if (typeof e != 'undefined') e.preventDefault();
	}

	Build.selectCard = function(e) {
		var el = $(this);

		Build.box.card = el.attr('data-card-title');

		$('.card-image').attr('src', el.attr('data-card-image'));

		var card_options, card_message;

		card_options = $('#card-options .card-options');
		card_message = $('#card-options .card-message');

		card_options.slideUp(function() {
			card_message.slideDown(function() {
				Build.updateBox();
				$('#message').focus();
			});
		});

		if (typeof e != 'undefined') e.preventDefault();
	}

	Build.changeCard = function(e) {
		var section, card_options, card_message;

		section = $('#card-options');
		card_options = $('.card-options', section);
		card_message = $('.card-message', section);

		card_message.slideUp(function() {
			card_options.slideDown();
		});

		if (typeof e != 'undefined') e.preventDefault();
	}

	Build.validateCard = function() {
		var section, message, outside;

		section = $('#card-options');
		message = $('#message');
		outside = $('input[name="card-outside"]', section);

		// No card selected
		if (typeof Build.box.card == '') {
			Boxfox.Modal.alert({
				title: 'Select a Card',
				message: 'Please select a card to complete your box.',
				confirmButton: 'Okay',
			});
			return false;
		}

		// No message
		if (message.val() == '' && !outside.is(':checked')) {
			Boxfox.Modal.confirm({
				title: "No Message on Card?",
				message: "Are you sure you don't want to write a message?",
				confirmButton: "Write a Message",
				cancelButton: "Leave Card Blank"
			}, function(confirmed){
				if (confirmed) {
					$('#message').focus();
				} else {
					// Update box object
					Build.box.card_location = (outside.is(':checked')) ? 'Outside' : 'Inside';

					// Finish up!
					Build.addBoxToCart();
					Build.goToStep(4);
				}
			});
			return false;
		}

		// Finish up!
		if (Build.box.shopify_product_id != '' && Build.box.shopify_variant_id != '') {
			for (var i = 0; i < window.cartJSON.items.length; i++) {
				var item = window.cartJSON.items[i];
				if (item.id == Build.box.shopify_variant_id) {
					Boxfox.Modal.confirm({
						title: "Update your box?",
						message: "It looks like you're editing a box that's already in your cart. Would you like to update this box with your new configuration?",
						confirmButton: "Update Box",
						cancelButton: "Add as a New Box"
					}, function(confirmed){
						if (confirmed) {
							// Update existing box
							Build.updateBoxInCart();
							Build.goToStep(4);
						} else {
							// Add as new box
							Build.addBoxToCart();
							Build.goToStep(4);
						}
					});

					return false;
				}
			}
		}
		Build.addBoxToCart();
		Build.goToStep(4);

		if (typeof e != 'undefined') e.preventDefault();
	};

	Build.updateMessage = function(e) {
		var message = $('#message');

		Build.box.message = message.val();

		if (Build.box.message == '') {
			$('.custom-box-message').addClass('no-message').html('(blank)');
		} else {
			$('.custom-box-message').removeClass('no-message').html(Build.box.message);
		}

		// Update local storage
		if (localStorage) {
			localStorage.setItem('custom-box', JSON.stringify(Build.box));
		}
	};

	Build.remainingCharacters = function(e) {
		var el, max;

		el = $('#message');
		max = el.attr('maxlength');

		if (max) {
			var remaining, message;

			remaining = (max - el.val().length);
			message = (remaining != 1) ? remaining + ' characters remaining' : remaining + ' character remaining';

			$('#remaining-characters').html(message);

			if (remaining === 0) {
				$('#remaining-characters').addClass('max-reached');
			} else {
				$('#remaining-characters').removeClass('max-reached');
			}
		}
	}

	Build.updateCardLocation = function(e) {
		var outside = $('#card-options input[name="card-outside"]');

		Build.box.card_location = (outside.is(':checked')) ? 'Outside' : 'Inside';

		if (Build.box.card_location == 'Outside') {
			$('#message').attr('disabled', true).val(Build.box.message);
		} else {
			$('#message').attr('disabled', false).val(Build.box.message).focus();
		}

		// Update local storage
		if (localStorage) {
			localStorage.setItem('custom-box', JSON.stringify(Build.box));
		}
	}

	Build.resetBoxComplete = function() {
		$('#build-complete .step-title.secondary').html('One Moment');
		$('#build-complete .step-title.primary').html(window.build_a_boxfox_language.step_4_title_working);
		$('#build-complete .step-description').html(window.build_a_boxfox_language.step_4_description_working);
		$('#build-complete .status-icon').removeClass('fa-check success').addClass('fa-circle-o-notch fa-spin');
		$('#build-complete .build-buttons').removeClass('visible');
	}

	Build.updateBoxComplete = function() {
		$('#build-complete .step-title.secondary').html('Done!');
		$('#build-complete .step-title.primary').html(window.build_a_boxfox_language.step_4_title_done);
		$('#build-complete .step-description').html(window.build_a_boxfox_language.step_4_description_done);
		$('#build-complete .status-icon').addClass('fa-check success').removeClass('fa-circle-o-notch fa-spin');
		$('#build-complete .build-buttons').addClass('visible');
	}

	Build.addBoxToCart = function(e) {
		// Always set the status to incomplete
		Build.box.status = 'incomplete';
		Build.updateBox();

		for (var i = 0, products = []; i < Build.box.items.length; i++) {
			var product = {
				id: Build.box.items[i].id,
				quantity: Build.box.items[i].quantity
			}

			products.push(product);
		}

		var data = {
			shop: window.shop,
			box_product_id: Build.box.product_id,
			box_variant_id: Build.box.variant_id,
			products: products
		};

		Build.validateConfiguration($.param(data));

		if (typeof e != 'undefined') e.preventDefault();
	};

	Build.updateBoxInCart = function() {
		// Remove existing box from cart
		var data = {
			id: Build.box.shopify_variant_id,
			quantity: 0
		};

		$.post('/cart/change.js', data, function(response) {
			Build.addBoxToCart();
		}, 'json');
	}

	Build.validateConfiguration = function(data) {
		var request = $.ajax({
			url: 'https://custom-box.abovemarket.com/custombox/validate',
			method: 'GET',
			data: data,
			dataType: 'jsonp',
			jsonpCallback: 'callback',
			crossDomain: true
		});

		request.done(function(data) {
			// Invalid combo snuck by
			if (data.status == 'invalid') {
				window.localStorage.clear();
				Build.displayErrorMessage();
				return false;
			}

			for (var i = 0, product = data; i < product.variants.length; i++) {
				var variant = product.variants[i];

				if ((variant.option1 == Build.box.color || variant.option2 == Build.box.color) && (variant.option1 == Build.box.box_size || variant.option2 == Build.box.box_size)) {
					var properties = {};

					// Card type
					properties['Card'] = Build.box.card;

					// Card location
					properties['Card Location'] = Build.box.card_location;

					// Card message
					if (Build.box.card_location == 'Outside') {
						properties['Message'] = '(blank)';
					} else {
						properties['Message'] = Build.box.message;
					}

					// Box contents
					properties['Box Contents'] = '';
					for (var x = 0; x < Build.box.items.length; x++) {
						var item = Build.box.items[x];

						if (properties['Box Contents'] != '') {
							properties['Box Contents'] += ', \n';
						}
						properties['Box Contents'] += (item.quantity + ' x ' + item.title);
					}

					var data = {
						id: variant.id,
						quantity: 1,
						properties: properties
					};

					// Update box object
					Build.box.status = 'complete';
					Build.box.shopify_product_id = product.id;
					Build.box.shopify_variant_id = variant.id;

					// Update local storage
					if (localStorage) {
						localStorage.setItem('custom-box', JSON.stringify(Build.box));
					}

					$.post('/cart/add.js', data);
					break;
				}
			}

			// Yay!  Added to the cart...
			Build.updateBoxComplete();

			// Update local storage
			if (localStorage) {
				localStorage.setItem('custom-box', JSON.stringify(Build.box));
			}

			// Rebuild cart json
			$.get('/cart.js', function(cart) {
				window.cartJSON = cart;
			}, 'json');

		});

		request.fail(Build.displayErrorMessage);
	};

	Build.displayErrorMessage = function() {
		Boxfox.Modal.alert({
			title: 'Error Processing Request',
			message: 'There was an error when trying to add your gift box to the cart. Please try again.',
			confirmButton: 'Okay',
		}, function(confirmed){
			if (confirmed) {
				Build.box.step = 3;
				Build.goToStep(3);
				location.reload(true);
			}
		});
	};

	Build.loadBox = function(id) {
		var data = {
			shop: window.shop,
			product_id: id
		};

		var request = $.ajax({
			url: 'https://custom-box.abovemarket.com/custombox/product',
			method: 'GET',
			data: data,
			dataType: 'jsonp',
			crossDomain: true,
			jsonpCallback: 'callback'
		});

		request.done(function(product) {
			// Custom box doesn't exist in our database
			if (product == '') {
				setTimeout(Build.resetBox, 0);
				return;
			}

			// Update status to complete
			Build.box.status = 'incomplete';

			// Update product & variant ids
			Build.box.shopify_product_id = Build.getParameterByName('shopify_product_id');
			Build.box.shopify_variant_id = Build.getParameterByName('shopify_variant_id');
			Build.box.card = Build.getParameterByName('card');
			Build.box.card_location = Build.getParameterByName('location');
			Build.box.message = Build.decodeEntities(Build.getParameterByName('message'));

			// Manage message formatting
			if (Build.box.message == '(blank)') {
				Build.box.message = '';
			}

			// Manage location formatting
			if (Build.box.card_location != 'Outside') {
				Build.box.card_location = 'Inside'
			}

			// Update box color
			for (var i = 0; i < product.variants.length; i++) {
				if (product.variants[i].id == Build.box.shopify_variant_id) {
					// Option 1: Box Color
					Build.box.color = product.variants[i].option1;

					// Option 2: Box Size
					Build.box.box_size = product.variants[i].option2;
					break;
				}
			}

			// Update box items
			for (var i = 0, contents; i < product.metafields.length; i++) {
				if (product.metafields[i].key == 'box-contents') {
					contents = product.metafields[i].value.split(',');
				}
			}

			for (var i = 0; i < contents.length; i++) {
				var data, id, quantity, item;

				data = contents[i].split(':');
				id = data[0];
				quantity = parseInt(data[1]);
				item = Build.itemByID(id);

				if (typeof item != 'undefined') {
					item['quantity'] = quantity;
					Build.box.items.push(item);
				}
			}

			// Update box step
			Build.box.step = 2;
			Build.goToStep(Build.box.step);

			setTimeout(Build.rebuildBox, 0)
		});
	}

	Build.goToStep = function(n) {
		var i = (n - 1), steps = $('#box-progress-bar .steps a');

		// Clear active class
		steps.removeClass('active');

		// Box Color
		if (Build.box.color != '') {
			steps.eq(0).addClass('completed').removeClass('disabled');
		} else {
			steps.eq(0).removeClass('completed').addClass('disabled');
		}

		if (Build.box.items.length > 0) {
			steps.eq(1).addClass('completed').removeClass('disabled');
		} else {
			steps.eq(1).removeClass('completed').addClass('disabled');
		}

		if (Build.box.card != '') {
			steps.eq(2).addClass('completed').removeClass('disabled');
		} else {
			steps.eq(2).removeClass('completed').addClass('disabled');
		}

		if (Build.box.status != 'incomplete') {
			steps.eq(3).addClass('completed').removeClass('disabled');
		} else {
			steps.eq(3).removeClass('completed').addClass('disabled');
		}

		steps.eq(i).addClass('active');

		Build.box.step = n;
		Build.widget.attr('data-current-step', n);
		Navigation.goToPageIndex(i);

		// Update local storage
		if (localStorage) {
			localStorage.setItem('custom-box', JSON.stringify(Build.box));
		}
	};

	Build.validateBoxInCart = function(box, callbackFunction) {
		alert('Build.validateBoxInCart was called!');

		Build.items = window.build_a_boxfox_items;

		var my_box, callback, request;

		my_box = box;

		callback = function() {};
		callbackFunction = (typeof callbackFunction == 'function') ? callbackFunction : function(){};
		request = $.ajax({
			url: 'https://custom-box.abovemarket.com/custombox/product',
			method: 'GET',
			data: {
				shop: window.shop,
				product_id: my_box.product_id
			},
			dataType: 'jsonp',
			jsonpCallback: 'callback',
			crossDomain: true,
			async: false
		});

		request.done(function(product) {
			var contents, unavailable_products = [];

			// Custom box doesn't exist in our database
			if (product == '') {
				// Remove box from cart
				$.post('/cart/change.js', {
					id: my_box.id,
					quantity: 0
				}, callback, 'json');
				return;
			}

			// Validate custom box contents...
			for (var i = 0; i < product.metafields.length; i++) {
				if (product.metafields[i].key == 'box-contents') {
					contents = product.metafields[i].value.split(',');
				}
			}

			for (var i = 0; i < contents.length; i++) {
				var data, id, quantity, o;

				data = contents[i].split(':');
				id = parseInt(data[0]);
				quantity = parseInt(data[1]);
				o = Build.itemByID(id);

				if (typeof o == 'undefined' || o.available == false) {
					var obj = {
						id: id,
						product_id: my_box.product_id,
						variant_id: my_box.id,
						box: my_box
					};
					unavailable_products.push(obj);
				}
			}

			// Notify the user
			if (unavailable_products.length > 0) {
				var q, message, obj;

				q = unavailable_products.length;
				message = 'Oh no! It looks like there ' + (q == 1 ? 'is an item' : 'are some items') + ' in your Build a BOXFOX that are now unavailable. We\'ll remove the box from your cart and the ' + (q == 1 ? 'item' : 'items') + ' from your box and you can review and replace ' + (q == 1 ? 'it' : 'them') + ' as needed.';

				obj = unavailable_products[0];

				console.log('Unavailable products');
				console.log(unavailable_products);

				Boxfox.Modal.alert({
					title: "Unavailable Items!",
					message: message,
					confirmButton: "Review Your BOXFOX",
				}, function(confirmed) {
					var data = {
						id: obj.variant_id,
						quantity: 0
					};

					var url = '/products/build-a-boxfox?shopify_product_id=' + obj.product_id + '&shopify_variant_id=' + obj.variant_id;

					for (var prop in obj.box.properties) {
						if (prop == 'Card') {
							url += ('&card' + obj.box.properties[prop]);
						}

						if (prop == 'Card Location') {
							url += ('&location' + obj.box.properties[prop]);
						}

						if (prop == 'Message') {
							url += ('&message' + obj.box.properties[prop]);
						}
					}

					// Remove box from cart
					$.post('/cart/change.js', data, function(){
						// Let's review the box
						window.location = encodeURI(url);

						//window.location = '/products/build-a-boxfox?box=' + unavailable_products[0].box;
					}, 'json');
				});
			}

			// Call that callback!
			callbackFunction();
		});
	};

	Build.toggleFavorite = function(e) {
		var item, id, obj, index, icons;

		item = $(this);
		id = item.attr('data-id');
		obj = Build.itemByID(id);
		index = Build.favorites.indexOf(obj);
		icons = $('.boxfox-favorite[data-id="' + obj.id + '"]');

		// Manage action
		if (index > -1) {
    	Build.favorites.splice(index, 1);
			icons.removeClass('saved').find('span').html('Save to Favorites');
			Boxfox.flashNotice({
				message: "Removed from your favorites"
			});
		} else {
			Build.favorites.push(obj);
			icons.addClass('saved').find('span').html('Remove from Favorites');
			Boxfox.flashNotice({
				message: "Added to your favorites"
			});
		}

		// Manage favorites icon
		if (Build.favorites.length) {
			$('#boxfox-favorites').addClass('visible');
		} else {
			$('#boxfox-favorites').removeClass('visible');
		}

		// Update local storage
		if (localStorage) {
			localStorage.setItem('custom-box-favorites', JSON.stringify(Build.favorites));
		}

		if (typeof e != 'undefined') e.preventDefault();
	}

	Build.showFavorites = function() {
		var source, template, html;

		source = $('#modal-favorites-template').html();
		template = Handlebars.compile(source);
		html = template(Build.favorites);

		var showItem = function(e) {
			Build.showItemInfo.call(this);
			Boxfox.Modal.hide();
			e.preventDefault();
		}

		var onload = function() {
			$('.modal-favorites .boxfox-buy-buttons button[data-action="increase"]').on('click', Build.increaseItem);
			$('.modal-favorites .boxfox-buy-buttons button[data-action="decrease"]').on('click', Build.decreaseItem);

			$('.modal-favorites .box-items .box-item .info').on('click', showItem);
			$('.modal-favorites .box-items .box-item .image').on('click', showItem)

			$('.modal-favorites .box-items .box-item .boxfox-favorite').on('click', Build.toggleFavorite);
		}

		Boxfox.Modal.page({
			content: html,
			onload: onload
		});
	}

	Build.manageBoxSize = function() {

		// Calculate total and remaining size
		var total_size, remaining_size;

		total_size = 0;
		remaining_size = Build.largest_box.size;

		// Calculate box total and remaining size
		for (var i = 0; i < Build.box.items.length; i++) {
			var item = Build.box.items[i];
			remaining_size -= (item.item_size * item.quantity);
			total_size += (item.item_size * item.quantity);
		}

		Build.box.total_size = total_size;
		Build.box.remaining_size = remaining_size;

		// Get current and next box sizes
		var current_box, next_box, box_size;

		// Get current box size based on items
		for (var i = 0; i < Build.box_sizes.length; i++) {
			if (total_size <= Build.box_sizes[i].size) {
				current_box = Build.box_sizes[i];
				box_size = current_box.title;
				break;
			}
		}

		// Get next box size based on items
		for (var i = 0; i < Build.box_sizes.length; i++) {
			if (Build.box_sizes[i].size > current_box.size) {
				next_box = Build.box_sizes[i];
				break;
			}
		}

		// Override native box size if we have flat items
		if (current_box.size == Build.smallest_box.size) {
			for (var i = 0; i < Build.box.items.length; i++) {
				for (var x = 0; x < window.build_a_boxfox_flat_items.length; x++) {
					if (Build.box.items[i].id == window.build_a_boxfox_flat_items[x].id) {
						box_size = next_box.title;
						total_size = current_box.size;
						break;
					}
				}
			}
		}

		// Update Build box size
		Build.box.box_size = box_size;

		// *** TEMPORARY HACK ***
		/*
		if (Build.box.box_size == 'Big' && Build.box.color == 'Nude') {
			Boxfox.Modal.alert({
				title: "Big, Nude Boxes Unavailable",
				message: "We apologize about the inconvenience but we're currently sold out of Big Nude Boxes. We'll switch you to a Black box so all your items fit. Alternatively, you can remove items and switch back to a Nude Box.",
				confirmButton: "Okay, Switch to Black",
			}, function(confirm){
				if (confirm) {
					Build.box.color = 'Black';
					Build.updateBox();
				}
			});
		}
		*/

		// Manage box variant
		Build.selectBoxVariantByAttributes();

		// Update Build box price
		var total = Build.box.base_price;
		for (var i = 0; i < Build.box.items.length; i++) {
			var item = Build.box.items[i];
			total += (item.price * item.quantity);
		}
		Build.box.price = total;

		// Update meter UI
		var left = ((total_size / Build.largest_box.size) * 100);
		if (left === 0) {
			left = '2px';
		} else {
			left += '%';
		}

		$('.size-meter-mask').css({ left: left });
	}

	Build.showBoxSizeMessage = function(e) {
		Boxfox.Modal.alert({
			title: "Box Sizes",
			message: "We want your gifts to look perfect, that's why we have three different box sizes. Never too much or too little space, and perfectly packed everytime!",
			confirmButton: "Got It!",
		});

		if (typeof e != 'undefined') e.preventDefault();
	}

	Build.selectBoxVariantByAttributes = function() {
		var selected_variant = null;

		for (var i = 0; i < Build.product.variants.length; i++) {
			var variant = Build.product.variants[i];

			if (variant.option1 == Build.box.color && variant.option2 == Build.box.box_size) {
				selected_variant = variant;
				break;
			}
		}

		if (selected_variant) {
			// Update Build Box Object
			Build.box.product_id = Build.product.id;
			Build.box.variant_id = selected_variant.id;
			Build.box.base_price = selected_variant.price;

			if (selected_variant.featured_image) {
				Build.box.image = selected_variant.featured_image.src;
			} else {
				Build.box.image = Build.product.image;
			}
		}
	}

	Build.init = function () {
		alert('Build.init was called!');
		Build.product = window.build_a_boxfox;
		Build.items = window.build_a_boxfox_items;
		Build.box_sizes = window.build_a_boxfox_sizes;

		Build.smallest_box = Build.box_sizes[0];
		for (var i = 0; i < Build.box_sizes.length; i++) {
			if (Build.box_sizes[i].size < Build.smallest_box.size) {
				Build.smallest_box = Build.box_sizes[i];
			}
		}

		Build.largest_box = Build.box_sizes[0];
		for (var i = 0; i < Build.box_sizes.length; i++) {
			if (Build.box_sizes[i].size > Build.largest_box.size) {
				Build.largest_box = Build.box_sizes[i];
			}
		}

		Build.default_box = {
			step: 1,
			status: 'incomplete',
			product_id: '',
			variant_id: '',
			image: '',
			color: '',
			card: '',
			message: '',
			card_location: 'Inside',
			items: [],
			box_size: Build.smallest_box.title,
			remaining_size: Build.largest_box.size,
			base_price: 0,
			price: 0
		};

		Build.box = $.extend({}, Build.default_box);

		Build.favorites = [];

		Build.widget = $('#custom-box-widget');
		Build.boxImages = $('.box-images', Build.widget);
		Build.boxContentsItems = $('.custom-box-contents .box-images', Build.widget);
		Build.boxTrayItems = $('.custom-box-tray-items .box-images', Build.widget);
		Build.boxListItems = $('.list-items', Build.widget);

		// Register Handlebars helper methods
		Handlebars.registerHelper('formatMoney', function(price) {
			return '$' + (price / 100).toFixed(2);
		});

		Handlebars.registerHelper('sizeImage', function(image) {
			var extension = image.split('.').pop();
			return image.replace('.' + extension, '_grande.' + extension);
		});

		Handlebars.registerHelper('quantity', function() {
			return Build.itemQuantityInBox(this);
		});

		Handlebars.registerHelper('inCart', function() {
			return (Build.itemQuantityInBox(this) > 0);
		});

		Handlebars.registerHelper('tooBig', function() {
			return (this.item_size > Build.box.remaining_size);
		});

		Handlebars.registerHelper('isFavorite', function() {
			var obj, index;

			obj = Build.itemByID(this);
			index = Build.favorites.indexOf(this);

			return (index > -1);
		})

		// Build reset via URL parameter
		if (Build.getParameterByName('reset')) {
			Build.resetBox();
		}

		// Build preload box via URL parameter
		if (Build.getParameterByName('shopify_product_id')) {
			Build.loadBox(Build.getParameterByName('shopify_product_id'));
		} else {
			$.extend(Build.box, JSON.parse(localStorage.getItem('custom-box')));
			$.extend(Build.favorites, JSON.parse(localStorage.getItem('custom-box-favorites')));
			setTimeout(Build.rebuildBox, 100);
		}

		// Build hash to preselect product collection
		if (Build.hasHashTag()) {
			var values, selects, matches;

			values = decodeURIComponent(window.location.hash).replace('#', '').toLowerCase().split(',');
			selects = $('select.filter-by, select.sort-by');
			matches = [];

			selects.each(function(){
				var select, options;

				select = $(this);
				options = $('option', select);

				options.each(function(){
					var option = $(this);

					for (var i = 0; i < values.length; i++) {
						var value = values[i];

						if (option.attr('value') == value) {
							option.prop('selected', true);
							matches.push(select);
						}
					}
				});
			});

			if (matches.length) {
				// Set default box color (if applicable)
				if (Build.box.color == '') {
					Build.box.color = Build.product.variants[0].title;
				}

				// Set step (always show step 2)
				Build.box.step = 2;

				// Trigger change events
				for (var i = 0; i < matches.length; i++) {
					matches[i].trigger('change');
				}
			}
		}

		// Bind event handlers
		$('#box-progress-bar .steps a').on('click', function(e) {
			var step = $(this);

			if (step.hasClass('disabled')) {
				return false;
			}

			Build.goToStep(step.attr('data-step'));

			e.preventDefault();
		});

		$('.box-color-options-list a').on('click', Build.selectBoxColor);

		$('.boxfox-buy-buttons button[data-action="increase"]').on('click', Build.increaseItem);
		$('.boxfox-buy-buttons button[data-action="decrease"]').on('click', Build.decreaseItem);

		$('.list-items').on('click', '.remove', Build.decreaseItem);

		$('.box-images').on('click', 'a:not(.selected-box)', Build.showItemInfo);

		$('.box-items .box-item .info').on('click', Build.showItemInfo);
		$('.box-items .box-item .image').on('click', Build.showItemInfo)

		$('#boxfox-favorites').on('click', Build.showFavorites);
		$('.box-items .box-item .boxfox-favorite').on('click', Build.toggleFavorite);

		$('#complete-box, #complete-box-tray').on('click', Build.validateItems);

		$('#card-options .addToCart').on('click', Build.validateCard);
		$('#card-options .card-options-list a').on('click', Build.selectCard);
		$('#card-options .card-message a').on('click', Build.changeCard);

		$('#message').on('keyup', Build.updateMessage);
		$('#message').on('keyup', Build.remainingCharacters);

		$('#card-options input[name="card-outside"]').on('click', Build.updateCardLocation);

		$('.size-meter-box a, .list-box-size a, .custom-box-tray-current-box-size a').on('click', Build.showBoxSizeMessage);

		$('[data-build-step]').on('click', function(e) {
			Build.goToStep($(this).attr('data-build-step'));
			e.preventDefault();
		});

		$('#continue-shopping').on('click', function(e) {
			Build.continueShopping();
			e.preventDefault();
		});

		// Enable UI enhancements
		Build.boxImages.sortable({
			items: 'li[id]',
			forceHelperSize: true,
			forcePlaceholderSize: true
			//cursorAt: { top: 0, left: 0 }
			//forcePlaceholderSize: true
			//containment: 'parent'
		}).disableSelection();

		// And proceed...
		setTimeout(function(){
			Build.goToStep(Build.box.step);
		}, 100);

		return Build;
	}

	// Return object
	return {
		Modal: Modal,
		flashNotice: flashNotice,
		Navigation: Navigation.init(),
		Build: Build
	};
}());

var Klaviyo = (function() {
	var identity;

	function getParameter(name, url) {
		if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");

    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);

    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
	}

	function identify() {
		var cookie = Cookies.get('__kla_id');

		if (cookie) {
			this.identity = JSON.parse(window.atob(cookie));
		}

		return this.identity;
	}

	function successCallback(response) {
		// console.log('Success!');
		// console.log(response);
	}

	function errorCallback(response) {
		console.log('Error!');
		console.log(response);

		if (response.status == 400) {
			// Identify ourselves if possible
			identity = Klaviyo.identify();

			if (identity) {
				window._learnq = window._learnq || [];

				// Update identity
				window._learnq.push(['identify', this.identity]);

				// Display success message
				successCallback();
			}

		}
	}

	function submit(data, success, error) {
		success = success ? success : successCallback;
		error = error ? error : errorCallback;

		$.ajax({
			method: "POST",
			url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
			async: true,
			crossDomain: true,
			headers: {
				"content-type": "application/x-www-form-urlencoded",
				"cache-control": "no-cache"
			},
			data: data,
			success: success,
			error: error
		});
	}

	// Return public properties & methods
	return {
		identify: identify,
		submit: submit
	}
})();

var BOXFOX = angular.module('BOXFOX', ['ngSanitize']);

BOXFOX.helpers = {
	getParameter: function(name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, "\\$&");

		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
				results = regex.exec(url);

		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	}
}

BOXFOX.config(['$interpolateProvider', function($interpolateProvider) {
	// Change Angular output syntax so it doesn't conflict with Shopify liquid syntax
	$interpolateProvider.startSymbol('[{').endSymbol('}]');
}]);

BOXFOX.filter('range', function() {
	return function(input, min, max) {
		min = parseInt(min);
		max = parseInt(max);
		for (var i = min; i <= max; i++) {
			input.push(i);
		}
		return input;
	}
});

BOXFOX.service('NotificationService',
	['$rootScope', '$compile', '$timeout', function($rootScope, $compile, $timeout) {

	var element = null;

	var queue = [];

	var templates = {
		alert: '#app-notification-alert',
		confirm: '#app-notification-confirmation',
		miniPage: '#app-notification-mini-page',
	}

	var notification = this;

	notification.show = function() {
		// Do we have an active modal?
		// If so, lets wait our turn
		if (element != null) {
			return false;
		}

		// Do we have any requests in the queue?
		// If not, lets just wait until we have some to show
		if (queue.length == 0) {
			return false;
		}

		// If we've reached this far that means we're first in line
		// You may proceed with the dialog
		var modal = queue.shift();

		// Add notification type-specific event handling
		if (modal.type == 'alert') {

			// Confirmation Callback
			modal.confirmCallback = function(e) {
				notification.hide();
				modal.callback(true);
			};

			// Keyboard events
			$(document).on('keydown.app-modal', function(e) {
				// Enter key
				if (e.which == 13) { modal.confirmCallback(e); }
			});
		}

		if (modal.type == 'confirm') {

			// Confirmation Callback
			modal.confirmCallback = function() {
				var result = modal.callback(true);

				if (result != false) {
					notification.hide();
				}
			};

			// Cancel Callback
			modal.cancelCallback = function() {
				notification.hide();
				modal.callback(false);
			};

			// Keyboard events
			$(document).on('keydown.app-modal', function(e) {
				// Enter key
				if(e.which == 13) { modal.confirmCallback(e); }

				// Escape key
				if(e.which == 27) { modal.cancelCallback(e); }
			});
		}

		if (modal.type == 'miniPage') {
			modal.backCallback = function() {
				notification.hide();
			};

			// Keyboard events
			$(document).on('keydown.app-modal', function(e) {
				// Escape key
				if(e.which == 27) { modal.backCallback(e); }
			});
		}


		// Create a scope
		var scope = $rootScope.$new();
		angular.extend(scope, modal);

		// Populate a template
		var template = $(templates[modal.type]).html();
		var html = $compile(template)(scope);

		// Add modal to DOM
		$('html').addClass('has-modal');
		//$('body').append(html);
		if (modal.appendTarget) {
			modal.appendTarget.append(html);
		} else {
			$('body').append(html);
		}

		// Attach modal to scope.notification object
		modal.html = html;

		// Make modal visible
		$timeout(function(){ html.addClass('visible'); }, 0);

		// Assign modal to element
		element = modal;

		// Append optional angular compiled controller
		if (modal.controller) {
			$timeout(function(){
				$(modal.controller.target).append(modal.controller.html);
			},0);
		}

		// Call the onload method yo!
		if (modal.onload) {
			modal.onload();
		}

		return modal;
	}

	notification.hide = function() {
		if (!element) {
			return false;
		}

		var delay, modal;

		delay = 500;
		modal = $(element.html);

		$('html').removeClass('has-modal');
		$(document).off('.app-modal');

		modal.removeClass('visible');
		$timeout(function(){
			// Remove modal from DOM
			modal.remove();

			// Clear Modal object
			element = null;

			// Request next modal in queue
			notification.show();
		}, delay);

		return modal;
	}

	notification.alert = function(options, fn) {
		// Define data object
		var data = {}

		// Set defaults
		var settings = {
			title: "Alert!",
			message: "This is an alert message",
			confirmButton: "Okay"
		};

		// Define callback (if applicable)
		fn = fn || function(){};

		// Extend data object with defaults and user defined options
		$.extend(data, settings, options);

		// Extend data object with type and callback
		data.type = 'alert';
		data.callback = fn;

		// Add our data to the queue
		queue.push(data);

		// Request to be shown
		notification.show();
	}

	notification.confirm = function(options, fn) {
		// Define data object
		var data = {}

		// Set defaults
		var settings = {
			title: "Confirmation!",
			message: "This is a confirmation message",
			confirmButton: "Okay",
			cancelButton: "Cancel",
			style: ''
		};

		// Define callback (if applicable)
		fn = fn || function(){};

		// Extend data object with defaults and user defined options
		$.extend(data, settings, options);

		// Extend data object with type and callback
		data.type = 'confirm';
		data.callback = fn;

		// Add our data to the queue
		queue.push(data);

		// Request to be shown
		notification.show();
	}

	notification.miniPage = function(options) {
		// Define data object
		var data = {}

		// Set defaults
		var settings = {
			content: "",
			backButton: "Back",
			onload: function() {}
		};

		// Extend data object with defaults and user defined options
		$.extend(data, settings, options);

		// Extend data object with type and callback
		data.type = 'miniPage';

		// Add our data to the queue
		queue.push(data);

		// Request to be shown
		notification.show();
	}


	return notification;
}]);

BOXFOX.controller('GiftBoxController',
	['$scope', '$window', '$http', '$q', '$timeout', 'DataService',
	function($scope, $window, $http, $q, $timeout, $data) {

	var giftbox = this;

	// Settings
	giftbox.data = $data;
	giftbox.settings = $data.settings;

	// Model
	giftbox.model = {};
	giftbox.model.packaging = {};
	giftbox.model.packaging_complete = false;

	giftbox.model.items = [];
	giftbox.model.items_complete = false;

	giftbox.model.card = {};
	giftbox.model.card_message = '';
	giftbox.model.card_blank = false;
	giftbox.model.card_complete = false;

	giftbox.model.current_step = 1;

	giftbox.model.status = 'incomplete';

	giftbox.model.favorites = [];

	// Properties
	giftbox.packaging_map = {};
	giftbox.modal_favorites = false;
	giftbox.modal_product = null;
	giftbox.navigation = {
		'slider': $('.giftbox-pages'),
		'track': $('.giftbox-page-track'),
		'pages': $('.giftbox-page'),
		'current_page': 1,
		'track_width': 0,
		'track_height': 0,
	}
	giftbox.sort_by = 'featured';
	giftbox.filter_by = {};

	// Helpers
	giftbox.getParameter = function(name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, "\\$&");

		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
				results = regex.exec(url);

		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	}

	// Methods
	giftbox.init = function() {
		console.log('Initialized!');
		console.log('Data is...');
		console.log($data);

		giftbox.getProducts().then(function() {
			var local = giftbox.getSavedData();


			console.log(' - - - local');
			console.log(local);

			if (local) {
				if (local.status == 'complete') {
					giftbox.removeSavedData();
				} else {
					giftbox.restoreSavedData(local);
				}
			}

			// Check for filters on page load
			$timeout(function(){
				var filters = giftbox.getParameter('filter_by');
				if (filters) {
					// Support multiple filters
					filters = filters.split('|');

					console.log('filters', filters);

					// Update filters
					for (var i = 0; i < filters.length; i++) {
						giftbox.autoApplyFilter(filters[i]);
					}

					// Apply filters
					giftbox.applyFilters();
				}

				var product = giftbox.getParameter('product');
				if (product) {
					if (isNaN(product)) {
						var item = giftbox.getItemByHandle(product);
					} else {
						var item = giftbox.getItemByID(product);
					}

					giftbox.showItemInfo(item);
				}
			}, 0);

		});


	}

	giftbox.autoApplyFilter = function(value) {
		var select, option, group;

		option = $('option[value="'+value+'"]');
		select = option.closest('select');
		group = select.data('group');

		console.log(value);
		console.log(option);
		console.log(select);

		giftbox.filter_by[group] = value;
	}

	giftbox.getProducts = async function() {
		var defer = $q.defer();
		var promises = [];

		for (var i = 0; i < giftbox.data.collection_pages.length; i++) {
			var page, page_number, offset, url, promise;
			page = giftbox.data.collection_pages[i];
			page_number = parseInt(page.title);
			offset = page_number > 1 ? ((page_number - 1) * 250) : 0;

			url = '/collections/' + giftbox.data.collection.handle;
			url += '?view=build_json';
			url += '&page=' + page_number;

			// console.log('page', page);
			// console.log('page_number', page_number);
			// console.log('offset', offset);
			// console.log('URL', url);

			promise = $http({ method: 'GET', url: url }).then(function(response) {
				var data = eval(response.data);

				// console.log('data', data);

				for (var i = 0; i < data.items.length; i++) {
					// console.log('Adding item...');
					// console.log(data.items[i]);
					giftbox.data.items.push(data.items[i]);
				}
			});

			promises.push(promise);
          await $q.all(promise).then(function(){
			defer.resolve();
		});
		}

		return defer.promise;
	}

	giftbox.getSavedData = function() {
		return JSON.parse(localStorage.getItem('giftbox'));
	}

	giftbox.setSavedData = function() {
		console.log('- - - SAVING DATA - - -');
		console.log(giftbox.model);

		localStorage.setItem('giftbox', JSON.stringify(giftbox.model));
	}

	giftbox.removeSavedData = function() {
		localStorage.removeItem('giftbox');
	}

	giftbox.restoreSavedData = function(local) {
		console.log('restoring saved data');
		console.log(local);

		// Update object data with favorites and quantities
		giftbox.updateDataWithSavedData(local);

		// Go to last completed step
		$timeout(function(){
			giftbox.goToPage(local.current_step);
		}, 10);

		// Create box if interrupted
		if (local.current_step == 4) {
			$timeout(function(){
				giftbox.createGiftBox();
			}, 10);
		}
	}

	giftbox.updateDataWithSavedData = function(local) {
		// Restore model data
		giftbox.model = local;

		// Packaging array
		giftbox.selectPackaging(local.packaging.id);

		// Items array
		for (var i = 0; i < local.items.length; i++) {
			for (var x = 0; x < giftbox.data.items.length; x++) {
				if (local.items[i].id == giftbox.data.items[x].id) {
					// Update data with quantity
					giftbox.data.items[x].quantity = local.items[i].quantity;

					// Remove item from array
					giftbox.model.items.splice(i, 1);

					// Push item on to array (from data array)
					giftbox.model.items.push(giftbox.data.items[x]);
				}
			}
		}

		// Favorites array
		for (var i = 0; i < local.favorites.length; i++) {
			for (var x = 0; x < giftbox.data.items.length; x++) {
				if (local.favorites[i].id === giftbox.data.items[x].id) {
					giftbox.data.items[x].favorite = local.favorites[i].favorite;
				}
			}
		}


	}

	$scope.$watch(function() {
		return giftbox.model;
	}, giftbox.setSavedData, true);

	// Paging
	giftbox.initPages = function() {
		giftbox.layout();
		$(window).on('resize', giftbox.layout);
	}

	giftbox.layout = function() {
		// Define width
		giftbox.navigation.track.width('auto');
		giftbox.navigation.track_width = giftbox.navigation.track.width();

		// Update page widths
		giftbox.navigation.pages.width(giftbox.navigation.track_width);

		// Update track width
		giftbox.navigation.track.width(giftbox.navigation.track_width * giftbox.navigation.pages.length);

		// Define page height
		giftbox.navigation.track.height('auto');
		giftbox.navigation.track_height = $(window).height();

		// Update track position
		giftbox.navigation.track.css({
			transition: 'none',
			transform: 'translate3d(-' + ((giftbox.navigation.current_page - 1) * giftbox.navigation.track_width) + 'px, 0, 0)'
		});

	}

	giftbox.goToPage = function(n, $event) {
		if ($event) {
			var target = $($event.currentTarget);
			if (target.hasClass('disabled')) {
				return;
			}
		}

		// Go to page
		giftbox.navigation.current_page = n;
		giftbox.model.current_step = n;

		// Animate to page
		giftbox.navigation.track.css({
			transition: 'transform 500ms ease',
			transform: 'translate3d(-' + ((n - 1) * giftbox.navigation.track_width) + 'px, 0, 0)'
		});

		// Scroll to top
		var target_top = $('#giftbox-progress-bar').offset().top;

		if ($(document).scrollTop() > target_top) {
			$timeout(function(){
				$('html, body').animate({ scrollTop: target_top }, 500);
			}, 500);
		}
	}

	giftbox.nextPage = function() {
		var n = Math.min(giftbox.navigation.pages.length, (giftbox.navigation.current_page + 1));

		giftbox.goToPage(n);
	}

	giftbox.prevPage = function() {
		var n = Math.max(0, (giftbox.navigation.current_page - 1));

		giftbox.goToPage(n);
	}

	giftbox.pageClass = function(n) {
		var css_class = '';

		// Step 1
		if (n == 1) {
			if (giftbox.navigation.current_page == 1) {
				css_class = 'active';
			} else if (giftbox.model.packaging_complete) {
				css_class = 'completed';
			} else {
				css_class = 'disabled';
			}
		}

		// Step 2
		if (n == 2) {
			if (giftbox.navigation.current_page == 2) {
				css_class = 'active';
			} else if (giftbox.model.items_complete) {
				css_class = 'completed';
			} else if (giftbox.model.packaging_complete) {
				css_class = 'accessible';
			} else {
				css_class = 'disabled';
			}
		}


		// Step 3
		if (n == 3) {
			if (giftbox.navigation.current_page == 3) {
				css_class = 'active';
			} else if (giftbox.model.card_complete) {
				css_class = 'completed';
			} else if (giftbox.model.items_complete) {
				css_class = 'accessible';
			} else {
				css_class = 'disabled';
			}
		}


		// Step 4
		if (n == 4) {
			if (giftbox.navigation.current_page == 4) {
				css_class = 'active';
			} else if (giftbox.model.status == 'complete') {
				css_class = 'completed';
			} else {
				css_class = 'disabled';
			}
		}

		return css_class;
	}


	// Filters
	giftbox.containsAny = function(str, arr) {
		// Force lowercase
		str = str.toLowerCase();

		// Locate string in array (also lowercase)
		for (var i = 0; i != arr.length; i++) {
			 var substring = arr[i].toLowerCase();
			 if (str.indexOf(substring) != - 1) {
				 return true;
			 }
		}

		return false;
	}

	giftbox.visibleItemsCount = function() {
		var count = 0;
		for (var i = 0; i < giftbox.data.items.length; i++) {
			count += giftbox.data.items[i].visible ? 1 : 0;
		}
		return count;
	}

	giftbox.filterItems = function() {
		var filters = [];
		var no_items = $('.custom-box-no-items');

		// Populate filters array
		for (filter in giftbox.filter_by) {
			if (giftbox.filter_by[filter] != '') {
				filters.push(giftbox.filter_by[filter]);
			}
		}

		console.log('filters');
		console.log(filters);

		if (filters.length === 0) {

			// Show all items
			for (var i = 0; i < giftbox.data.items.length; i++) {
				giftbox.data.items[i].visible = true;
			}

			// Hide no results message
			no_items.hide();
		} else {

			// Toggle item visibility
			for (var i = 0; i < giftbox.data.items.length; i++) {
				var item = giftbox.data.items[i];

				// Make item visible to start
				item.visible = true;

				for (var j = 0; j < filters.length; j++) {
					if (!giftbox.containsAny(filters[j], item.tags)) {
						item.visible = false;
					}
				}
			}

			// Show/hide no results message as needed
			if (giftbox.visibleItemsCount() == 0) {
				no_items.show();
			} else {
				no_items.hide();
			}
		}
	}

	giftbox.searchItems = function() {
		var terms = $('#search-items').val().toLowerCase().split(' ');
		var no_items = $('.custom-box-no-items');

		console.log('searchItems has been called!');
		console.log(terms);

		// Toggle item visibility
		for (var i = 0; i < giftbox.data.items.length; i++) {
			var item = giftbox.data.items[i];

			if (item.visible) {
				var show, vendor_match, title_match, description_match, tags_match;

				show = false;
				vendor_match = giftbox.containsAny(item.vendor, terms);
				title_match = giftbox.containsAny(item.title, terms);
				description_match = giftbox.containsAny(item.description, terms);
				tags_match = giftbox.containsAny(item.tags.toString(), terms);

				if (vendor_match || title_match || description_match || tags_match) {
					show = true;
				}

				if (show) {
					item.visible = true;
				} else {
					item.visible = false;
				}
			}
		}

		// Show/hide no results message as needed
		if (giftbox.visibleItemsCount() == 0) {
			no_items.show();
		} else {
			no_items.hide();
		}
	}

	giftbox.applyFilters = function() {
		giftbox.filterItems();
		giftbox.searchItems();
	}

	giftbox.sortByIndex = function(a, b) {
		var a_index = Number(a.index);
		var b_index = Number(b.index);
		return (a_index < b_index) ? -1 : ((a_index > b_index) ? 1 : 0);
	}

	giftbox.sortByPrice = function(a, b) {
		var a_price = Number(a.price);
		var b_price = Number(b.price);
		return (a_price < b_price) ? -1 : ((a_price > b_price) ? 1 : 0);
	}

	giftbox.sortBySize = function(a, b) {
		var a_size = Number(a.size_constraint);
		var b_size = Number(b.size_constraint);
		return (a_size < b_size) ? -1 : ((a_size > b_size) ? 1 : 0);
	}

	giftbox.sortItems = function() {
		var method = giftbox.sort_by;

		if (method == 'featured') {
			$data.items.sort(giftbox.sortByIndex);
		} else if (method == 'price-ascending') {
			$data.items.sort(giftbox.sortByPrice);
		} else if (method == 'price-descending') {
			$data.items.sort(giftbox.sortByPrice);
			$data.items.reverse();
		} else if (method == 'size-ascending') {
			$data.items.sort(giftbox.sortBySize);
		} else if (method == 'size-descending') {
			$data.items.sort(giftbox.sortBySize);
			$data.items.reverse();
		}
	}


	// Step 1. Packaging
	giftbox.selectPackaging = function(variant_id, next_page) {
		var packaging, total_size;

		// Locate packaging by variant ID
		for (var i = 0; i < giftbox.data.box.variants.length; i++) {
			if (giftbox.data.box.variants[i].id == variant_id) {
				packaging = giftbox.data.box.variants[i];
				break;
			}
		}

		// Calculate total item size
		total_size = giftbox.totalSize();

		// Verify packaging
		if (total_size > 0 && packaging) {
			// Map new packaging
			giftbox.generatePackagingMap(packaging);

			// Can we fit the items in the new packaging?
			if (total_size > giftbox.packaging_map.matching.largest.size_constraint) {

				// Alert the user that this isn't going to work
				alert('You have too many items to fit this packaging type. Please remove some items before switching to a ' + giftbox.packaging_map.matching.largest.title);

				// Revert the packaging map back to the previous setup
				giftbox.generatePackagingMap(giftbox.model.packaging);

				// Go to step two so they can remove product
				giftbox.goToPage(2);

				return;
			}
		}

		// Update selected packaging
		if (packaging) {
			giftbox.model.packaging = packaging;
			giftbox.model.packaging_complete = true;
			giftbox.generatePackagingMap(packaging);
			giftbox.toggleItemAvailability();
		}

		// Go to the next page (if applicable)
		if (packaging && next_page) {
			giftbox.goToPage(2);
		}
	}

	giftbox.optionIndexByTitle = function(item, title) {
		var index = item.options.indexOf(title);

		return (index > -1) ? (index + 1) : index;
	}

	giftbox.generatePackagingMap = function(variant) {

		var map, option_index, option_value;

		map = {};
		map.all = {}
		map.all.packaging = [];
		map.matching = {};
		map.matching.packaging = [];

		option_index = giftbox.optionIndexByTitle(giftbox.data.box, 'Box Color');
		option_value = variant['option' + option_index];

		// Add the smallest and largest packaging
		for (var i = 0, packaging; i < giftbox.data.box.variants.length; i++) {
			packaging = giftbox.data.box.variants[i];

			// Add it to the "all" array
			map.all.packaging.push(packaging);

			// Locate the smallest
			if (!map.all.smallest || packaging.size_constraint < map.all.smallest.size_constraint) {
				map.all.smallest = packaging;
			}

			// Locate the largest
			if (!map.all.largest || packaging.size_constraint > map.all.largest.size_constraint) {
				map.all.largest = packaging;
			}

			// Do we have a matching package type?
			if (packaging['option' + option_index] == option_value) {

				// Add it to the "matching type" array
				map.matching.packaging.push(packaging);

				// Locate the smallest
				if (!map.matching.smallest || packaging.size_constraint < map.matching.smallest.size_constraint) {
					map.matching.smallest = packaging;
				}

				// Locate the largest
				if (!map.matching.largest || packaging.size_constraint > map.matching.largest.size_constraint) {
					map.matching.largest = packaging;
				}
			}
		}

		// Add the current packaging
		map.all.current = giftbox.model.packaging;
		map.matching.current = giftbox.model.packaging;

		// Sort the packaging arrays by size constraint (smallest to largest)
		map.all.packaging.sort(giftbox.sortBySize);
		map.matching.packaging.sort(giftbox.sortBySize);

		// Add previous and next size packaging (all packaging)
		map.all.previous = null;
		map.all.next = null;
		for (var i = 0, packaging; i < map.all.packaging.length; i++) {
			packaging = map.all.packaging[i];

			if (packaging.size_constraint < variant.size_constraint) {
				map.all.previous = packaging;
			}

			if (packaging.size_constraint > variant.size_constraint) {
				map.all.next = packaging;
				break;
			}
		}

		// Add next size packaging (matching)
		map.matching.previous = null;
		map.matching.next = null;
		for (var i = 0, packaging; i < map.matching.packaging.length; i++) {
			packaging = map.matching.packaging[i];

			if (packaging.size_constraint < variant.size_constraint) {
				map.matching.previous = packaging;
			}

			if (packaging.size_constraint > variant.size_constraint) {
				map.matching.next = packaging;
				break;
			}
		}

		console.log('- - - - - PACKAGING MAP - - - - -');
		console.log(map);

		// Update packaging map
		giftbox.packaging_map = map;
	}

	giftbox.inArray = function(arr, key, value) {
		if (arr) {
			for (var i = 0; i < arr.length; i++) {
				if (arr[i][key] == value) {
					return true;
				}
			}
		}
		return false;
	}

	giftbox.optionValueByTitle = function(title) {
		var option_index, option_value;

		option_index = giftbox.optionIndexByTitle(giftbox.data.box, title);
		option_value = giftbox.model.packaging['option' + option_index];

		return option_value;
	}

	giftbox.explainBoxSizes = function() {
		Boxfox.Modal.alert({
			title: "Box Sizes",
			message: "We want your gifts to look perfect, that's why we have three different box sizes. Never too much or too little space, and perfectly packed everytime!",
			confirmButton: "Got It!",
		});
	}

	// Step 2. Items
	giftbox.getItemByID = function(id) {
		for (var i = 0; i < giftbox.data.items.length; i++) {
			if (giftbox.data.items[i].id == id) {
				return giftbox.data.items[i];
			}
		}
	}

	giftbox.getItemByHandle = function(handle) {
		for (var i = 0; i < giftbox.data.items.length; i++) {
			if (giftbox.data.items[i].handle == handle) {
				return giftbox.data.items[i];
			}
		}
	}

	giftbox.formatMoney = function(cents) {
		return (isNaN(cents)) ? '' : '$' + (cents / 100).toFixed(2);
	}

	giftbox.subtotal = function() {
		var subtotal = 0;

		// Add base box
		if (giftbox.model.packaging.price) {
			subtotal += giftbox.model.packaging.price;
		}

		// Add line items
		for (var i = 0; i < giftbox.model.items.length; i++) {
			subtotal += (giftbox.model.items[i].price * giftbox.model.items[i].quantity);
		}

		return giftbox.formatMoney(subtotal);
	}

	giftbox.totalSize = function() {
		var total_size = 0;
		for (var i = 0; i < giftbox.model.items.length; i++) {
			total_size += (giftbox.model.items[i].size_constraint * giftbox.model.items[i].quantity);
		}
		return total_size;
	}

	giftbox.containsFlatItems = function() {
		var response = false;

		for (var i = 0; i < giftbox.model.items.length; i++) {
			if (giftbox.inArray(giftbox.data.flat_items, 'id', giftbox.model.items[i].id)) {
				response = true;
				break;
			}
		}

		return response;
	}

	giftbox.minimumBoxSize = function() {
		var minimum_size = giftbox.totalSize();

		// Hard code to "Regular" sized box
		if (giftbox.containsFlatItems()) {
			minimum_size = 13;
		}

		return minimum_size;
	}

	giftbox.sizeRemaining = function() {
		var map, total_size, remaining_size, max_remaining_size, minimum_box_size;

		map = giftbox.packaging_map;
		total_size = giftbox.totalSize();
		remaining_size = map.matching.current.size_constraint - total_size;
		max_remaining_size = map.matching.largest.size_constraint - total_size;
		minimum_box_size = giftbox.minimumBoxSize();

		console.log('- - map - -');
		console.log(map);

		console.log('- - packaging size - -');
		console.log(map.matching.current.size_constraint);

		console.log('- - total size - -');
		console.log(total_size);

		console.log('- - remaining size - -');
		console.log(remaining_size);

		console.log('- - max remaining size - -');
		console.log(max_remaining_size);

		console.log('- - minimum box size - -');
		console.log(minimum_box_size);

		// Adjust packaging size up or down as needed
		if (map.matching.previous && total_size <= map.matching.previous.size_constraint && map.matching.current.size_constraint > minimum_box_size) {
			console.log('Lets go to the next size DOWN...');

			console.log('Next smallest packaging...');
			console.log(map.matching.previous);

			giftbox.selectPackaging(map.matching.previous.id);
		}
		else if (map.matching.next && total_size > map.matching.current.size_constraint) {
			console.log('Lets go to the next size UP...');

			console.log('Next largest packaging...');
			console.log(map.matching.next);

			giftbox.selectPackaging(map.matching.next.id);
		}
		else if (map.matching.next && map.matching.current.size_constraint < minimum_box_size) {
			console.log('BOX CONTAINS SPECIAL ITEMS!');
			console.log('Lets go to the next size UP...');

			console.log('Next largest packaging...');
			console.log(map.matching.next);

			giftbox.selectPackaging(map.matching.next.id);
		}
		else if (!map.matching.next && map.all.next && total_size == map.matching.current.size_constraint && total_size < map.all.next.size_constraint) {

			console.log('Larger size packaging available in a different Box Color!');

			$timeout(function(){
				answer = confirm('Your ' + giftbox.model.packaging.title + ' is currently full and cannot fit any more items. Do you want to switch to a ' + map.all.next.title + ' instead? You will be able to fit more items!');

				if (answer) {
					giftbox.selectPackaging(map.all.next.id);
					max_remaining_size = map.all.largest.size_constraint - total_size;
				}
			}, 0);
		}

		giftbox.checkDisabledPackaging();

		// Update meter UI
		var left = ((total_size / map.all.largest.size_constraint) * 100);
		if (left === 0) {
			left = '2px';
		} else {
			left += '%';
		}

		$('.size-meter-mask').css({ left: left });

		return max_remaining_size;
	}

	giftbox.checkDisabledPackaging = function() {

		/*
		if (giftbox.model.packaging.title == "Black / Regular") {
			var alternate;
			for (var i = 0, variant; i < giftbox.data.box.variants.length; i++) {
				variant = giftbox.data.box.variants[i];
				if (variant.title == "Nude / Regular") {
					alternate = variant.id;
					break;
				}
			}

			if (!giftbox.notified) {

				giftbox.notified = true;

				Boxfox.Modal.alert({
					title: "Regular, Black Boxes Unavailable",
					message: "We apologize about the inconvenience but we're currently sold out of Regular Black Boxes. We'll switch you to a Nude box so all your items fit. Alternatively, you can remove items and switch back to a Black Box.",
					confirmButton: "Okay, Switch to Nude",
				}, function(confirm){
					if (confirm) {
						giftbox.selectPackaging(alternate);
						$scope.$apply();

						giftbox.notified = false;
					}
				});
			}


		}
		*/

	}

	giftbox.increaseQuantity = function(item) {
		if (item.disabled) return

		item.quantity += 1;

		if (item.quantity == 1) {
			giftbox.model.items.push(item);
		}

		console.log('Item size constrain... ');
		console.log(item.size_constraint);

		Boxfox.flashNotice({
			message: item.title + " added to your box"
		});

		giftbox.toggleItemAvailability();
	}

	giftbox.decreaseQuantity = function(item) {
		item.quantity -= 1;

		if (item.quantity == 0) {
			for (var i = 0; i < giftbox.model.items.length; i++) {
				if (giftbox.model.items[i].id == item.id) {
					giftbox.model.items.splice(i, 1);
					break;
				}
			}
		}

		console.log('Item size constrain... ');
		console.log(item.size_constraint);

		Boxfox.flashNotice({
			message: item.title + " removed to your box"
		});

		giftbox.toggleItemAvailability();
	}

	giftbox.toggleItemAvailability = function() {
		var remaining_size = giftbox.sizeRemaining();

		for (var i = 0, item; i < giftbox.data.items.length; i++) {
			item = giftbox.data.items[i];

			if (item.size_constraint > remaining_size) {
				item.disabled = true;
			} else {
				item.disabled = false;
			}
		}
	}

	giftbox.showItemInfo = function(item) {
		// Cancel any outstanding promises
		$timeout.cancel(giftbox.modalItemPromise);

		// Update modal product
		giftbox.modal_product = item;

		// Initialize photo slider
		$timeout(giftbox.initPhotoSlider, 0);

		// Prevent scrolling
		$('html,body').addClass('no-scroll');
	}

	giftbox.hideItemInfo = function() {
		// Allow scrolling
		$('html,body').removeClass('no-scroll');

		// Animate modal
		$('#modal-product').removeClass('visible');

		// Destroy photo slider
		$timeout(giftbox.destroyPhotoSlider, 0);

		// Capture modal item promise
		giftbox.modalItemPromise = $timeout(function(){
			giftbox.modal_product = null;
		}, 100);
	}

	giftbox.initPhotoSlider = function() {
		// Init photo slider
		var slider = $('#modal-product .modal-product-images .product-slideshow');

		// Setup the new initialization
		slider.slick({
			adaptiveHeight: true,
			dots: true,
			swipe: true,
			appendDots: $('.modal-product-images .product-thumbnails'),
			customPaging: function(slider, i) {
				var thumbnail = $(slider.$slides[i]).data('thumbnail');
				return '<img src="' + thumbnail + '">';
			}
		});

		$('.modal-product-images img').imagesLoaded(function(){
			slider.slick('setPosition');
		});
	}

	giftbox.destroyPhotoSlider = function() {
		$('#modal-product .modal-product-images .product-slideshow').slick('unslick');
	}

	giftbox.toggleFavorite = function(item) {
		if (item.favorite) {
			giftbox.removeFromFavorites(item);
			Boxfox.flashNotice({
				message: "Removed from your favorites"
			});
		} else {
			giftbox.addToFavorites(item);
			Boxfox.flashNotice({
				message: "Added to your favorites"
			});
		}
	}

	giftbox.addToFavorites = function(item) {
		item.favorite = true;
		giftbox.model.favorites.push(item);
	}

	giftbox.removeFromFavorites = function(item) {
		item.favorite = false;

		for (var i = 0; i < giftbox.model.favorites.length; i++) {
			if (giftbox.model.favorites[i].id == item.id) {
				giftbox.model.favorites.splice(i, 1);
				break;
			}
		}
	}

	giftbox.showFavorites = function() {
		giftbox.modal_favorites = true;

		$('html,body').addClass('no-scroll');
	}

	giftbox.hideFavorites = function() {
		$('html,body').removeClass('no-scroll');
		$('#modal-favorites').removeClass('visible');

		$timeout(function(){
			giftbox.modal_favorites = null;
		}, 500);
	}

	giftbox.completeItems = function() {
		if (giftbox.model.items.length) {
			giftbox.model.items_complete = true;
			giftbox.goToPage(3);
		} else {
			Boxfox.Modal.alert({
				title: "Your Box is Empty",
				message: 'It looks like you haven\'t added anything to your box. Please add at least one item before proceeding.',
				confirmButton: "Okay",
			});
		}
	}

	// Step 3. Card and Message
	giftbox.selectCard = function(card) {
		giftbox.model.card = card;

		$('#message').focus();
	}

	giftbox.removeCard = function() {
		giftbox.model.card = {};
	}

	giftbox.updateCharacterCount = function() {
		var max_length = giftbox.settings.step3.message['max-characters'];

		return (max_length - giftbox.model.card_message.length);
	}

	giftbox.completeCard = function() {
    // Ensure files are selected
    if (giftbox.model.card.isUpsell) {
      var customCardInput = document.getElementById('customBrandedCard');
      if (customCardInput && !customCardInput.files[0]) {
        Boxfox.Modal.alert({
          title: 'Select File',
          message: 'Please select a file for your Custom Branded Card.',
          confirmButton: 'Okay',
        });
        return;
      }
    }

    var customLogoTag = document.getElementById('customLogoTag');
    if (customLogoTag && !customLogoTag.files[0]) {
      Boxfox.Modal.alert({
        title: 'Select File',
        message: 'Please select a file for your Logo Tag.',
        confirmButton: 'Okay',
      });
      return;
    }

		if (!giftbox.model.card.title) {
			Boxfox.Modal.alert({
				title: 'Select a Card',
				message: 'Please select a card to complete your box.',
				confirmButton: 'Okay',
			});
		} else if (giftbox.model.card_message.length == 0 && !giftbox.model.card_blank) {
			Boxfox.Modal.alert({
				title: "No Message on Card?",
				message: "Please add a message to your card.",
				confirmButton: "Okay",
			});
		} else {
			giftbox.model.card_complete = true;
			giftbox.goToPage(4);
			giftbox.createGiftBox();
		}
	}

	// Step 4. Add to Cart
	giftbox.createGiftBox = function() {
		var data, request;

		data = {
			'shop': $data.shop,
			'product_id': $data.box.id,
			'variant_id': giftbox.model.packaging.id,
			'items': []
		};

		for (var i = 0, item; i < giftbox.model.items.length; i++) {
			data.items.push({
				'product_id': giftbox.model.items[i].id,
				'variant_id': giftbox.model.items[i].variants[0].id,
				'quantity': giftbox.model.items[i].quantity
			});
		}

		request = $.ajax({
			url: 'https://concierge.boxfox.com/giftbox/create',
			method: 'GET',
			data: data,
			dataType: 'jsonp',
			jsonpCallback: 'callback',
			crossDomain: true
		});

		request.done(function(response) {
			if (response.status == 'error') {
				giftbox.displayErrors(response);
				giftbox.goToPage(3);
			} else {
				giftbox.addToCart(response);
			}
		});
	}

	giftbox.addToCart = function(response) {
		console.log(response);

    var formData = new FormData();

		// Card
		formData.append('properties[Card]', giftbox.model.card.title);
    formData.append('properties[Message]', giftbox.model.card_message);


		// Contents
		giftBoxContents = '';
		for (var i = 0, item; i < giftbox.model.items.length; i++) {
			item = giftbox.model.items[i];

			if (giftBoxContents != '') {
				giftBoxContents += ', \n';
			}

			giftBoxContents += (item.quantity + ' x ' + item.title);
		}

    formData.append('properties[Gift Box Content]', giftBoxContents);

		// Collateral
		if (giftbox.model.card.properties) {
			for(var prop in giftbox.model.card.properties) {
        formData.append(`properties[${prop}]`, giftbox.model.card.properties[prop]);
			}
		}

    formData.append('id', response.product.variants[0].id);
    formData.append('quantity', 1);

    if (giftbox.model.card.isUpsell) {
      var customCardInput = document.getElementById('customBrandedCard');
      if (customCardInput && customCardInput.files[0]) {
        formData.append('properties[_custom_branded_card]', customCardInput.files[0]);
      } else {
        alert('Please select a file for your Custom Branded Card');
        return;
      }
    }

    var customLogoTag = document.getElementById('customLogoTag');
    if (customLogoTag && customLogoTag.files[0]) {
      formData.append('properties[Custom Logo Tag]', 'Yes');
      formData.append('properties[_custom_logo_tag]', customLogoTag.files[0]);
    }

    // Add to cart using form data, add upsell items
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(json) {
      var properties = json.properties;
      var title = json.product_title;
      var items = [];

      if (properties._custom_branded_card && theme.customBrandedCard) {
        items.push({
          quantity: json.quantity,
          id: Number(theme.customBrandedCard),
          properties: {
            _is_upsell: true,
            _associated_box: json.key,
            For: title,
          }
        });
      }

      if (properties._custom_logo_tag && theme.customLogoTag) {
        items.push({
          quantity: json.quantity,
          id: Number(theme.customLogoTag),
          properties: {
            _is_upsell: true,
            _associated_box: json.key,
            For: title,
          }
        });
      }

      if (items.length) {
        fetch('/cart/add.js', {
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'POST',
          body: JSON.stringify({ items: items }),
        })
        .then(function(response) {
          if (response.ok) giftbox.finish();
        })
        .catch(function(error) { console.error({ error }) });
      } else {
        giftbox.finish();
      }
    })
    .catch(function(error) {
      console.log('Error: ', { error });
    });
	}

	giftbox.displayErrors = function(response) {
		if (response.errors.length > 1) {
			alert('There were a number of errors encountered.')
		} else {
			alert('There was an error! ' + response.errors[0].message);
		}
	}

	giftbox.finish = function() {
		// Update UI
		$timeout(function(){
			giftbox.model.status = 'complete';
		});

		// Navigation to cart page
		$timeout(function(){
			$window.location.href = '/cart';
		}, 1000);
	}

	return giftbox;
}]);

BOXFOX.controller('slickSlider',
	['$timeout',
	function($timeout) {
		return {
			restrict: 'A',
			link: function(scope,element,attrs) {
				$timeout(function() {
						$(element).slick(scope.$eval(attrs.slickSlider));
				});
			}
		}
}]);

BOXFOX.controller('Admin',
	['$scope', '$window', '$timeout', function($scope, $window, $timeout) {
	console.log('Admin Controller called', $scope);

	$scope.customer = {};
	$scope.selectedCard = 'Merci';
  $scope.displayLogoUpload = false;
  $scope.customBrandedCardUpload = document.getElementById('customBrandedCardUpload');
  $scope.customLogoTagUpload = document.getElementById('customLogoTagUpload');
  $scope.customBrandedCardInput = document.getElementById('customBrandedCard');
  $scope.customLogoTagInput = document.getElementById('customLogoTag');

  if ($scope.displayLogoUpload) {
    $scope.toggleCustomFileUploadDisplay('customLogoTagUpload', false);
  }


	$scope.menu_visible = false;

	$scope.showMenu = function() {
		$scope.menu_visible = true;
		//Cookies.set('menu_visible', true, { expires: 365 });
	}

	$scope.hideMenu = function() {
		$scope.menu_visible = false;
		//Cookies.set('menu_visible', false, { expires: 365 });
	}

	$scope.toggleMenu = function() {
		//console.log('Toggle menu');

		if ($scope.menu_visible) {
			$scope.hideMenu();
		} else {
			$scope.showMenu();
		}
	}

	$scope.sizeImage = function(url, size) {
		var extension = url.split('.').pop();
		size = (typeof size == 'undefined') ? '' : '_' + size;
		return url.replace('.' + extension, size + '.' + extension);
	}

	$scope.escapeHtml = function(html) {
		return html
			.replace(/"/g, "\x22")
			.replace(/'/g, "\x27");
	}

	$scope.clientLogo = function() {
		var url = '';

		if ($scope.customer.client && $scope.customer.client.logo_url) {
			url = 'https://concierge.boxfox.com/' + $scope.customer.client.logo_url;
		}

		return url;
	}

	$scope.pendingProposals = function() {
		var count = 0;

		if ($scope.customer.proposals) {
			for (var i = 0; i < $scope.customer.proposals.length; i++) {
				if ($scope.customer.proposals[i].status == 'Pending') {
					count += 1;
				}
			}
		}

		return count;
	}

	$scope.cardObject = function(collateral) {
		var obj = {
			type: 'card',
			title: collateral.shopify_product.title,
			image: collateral.shopify_product.image.src,
			properties: {}
		}

		// Collateral properties
		obj.properties['_collateral'] = JSON.stringify({
			shopify_product_id: collateral.shopify_product_id,
			type: collateral.type
		});

		obj.properties['Collateral'] = collateral.shopify_product.title;

		console.log('card object');
		console.log(obj);

		return obj;
	}

	$scope.defaultCard = function() {
		for (var i = 0; i < $scope.customer.collateral.length; i++) {
			if ($scope.customer.collateral[i].type == 'Card') {
				$scope.selectedCard = $scope.customer.collateral[i].shopify_product.title;
				break;
			}
		}
	}

	$scope.getCollateralCard = function() {
		var card = null;

		if ($scope.customer.collateral) {
			for (var i = 0; i < $scope.customer.collateral.length; i++) {
				if ($scope.customer.collateral[i].type == 'Card' && $scope.customer.collateral[i].shopify_product.title == $scope.selectedCard) {
					card = $scope.customer.collateral[i];
					break;
				}
			}
		}

		return card;
	}

	$scope.$watch('selectedCard', function() {
		$scope.manageCardProperties();

    /**
     * SDG Addition: hook into listener to display file upload on certain selection
     */
    if ($scope.selectedCard === 'Custom Branded Card') {
      $scope.toggleCustomFileUploadDisplay('customBrandedCardUpload', false);
    } else {
      $scope.toggleCustomFileUploadDisplay('customBrandedCardUpload', true);
      if ($scope.customBrandedCardInput) $scope.customBrandedCardInput.value = '';
    }
	});

  /**
   * SDG Addition: add watcher for custom logo tag checkbox
   */
  $scope.$watch('displayLogoUpload', function() {
    if ($scope.displayLogoUpload) {
      $scope.toggleCustomFileUploadDisplay('customLogoTagUpload', false);
    } else {
      $scope.toggleCustomFileUploadDisplay('customLogoTagUpload', true);
      if ($scope.customLogoTagInput) $scope.customLogoTagInput.value = '';
    }
  });

  /**
   * SDG Addition: function for toggle display of file uploads
   */
  $scope.toggleCustomFileUploadDisplay = function(id, hide) {
    if (!$scope[id]) return;

    if (hide) {
      $scope[id].classList.add('hide');
    } else {
      $scope[id].classList.remove('hide');
    }
  }

	$scope.manageCardProperties = function() {
		var card = $scope.getCollateralCard();

		if (card) {
			$scope.addCardPropertiesToForm(card);
		} else {
			$scope.removeCardPropertiesFromForm();
		}
	}

	$scope.addCardPropertiesToForm = function(card) {
		console.log('Adding form properties...');
		console.log(card);

		var json = JSON.stringify({
			shopify_product_id: card.shopify_product_id,
			type: card.type
		});

		$('<input id="card-property-list" type="hidden" name="properties[_collateral]" />').val($scope.escapeHtml(json)).insertAfter('#box-card');

		$('<input id="card-property-titles" type="hidden" name="properties[Collateral]" />').val(card.shopify_product.title).insertAfter('#box-card');

	}

	$scope.removeCardPropertiesFromForm = function() {
		console.log('Removing form properties...');

		$('#card-property-list').remove();
		$('#card-property-titles').remove();
	}

	$scope.getCustomer = function() {
		$.ajax({
			type: 'GET',
			url: 'https://concierge.boxfox.com/contact/info',
			data: {
				shop: $window.shop,
				shopify_customer: $window.shopify_customer,
				format: 'json'
			},
			async: true,
			crossDomain: true,
			dataType: 'jsonp',
			success: function(response) {
				console.log('Got customer info...');
				console.log(response);

				$scope.customer = response;

				$scope.defaultCard();

				$scope.$apply();
			},
			error: function(error) {
				console.log(error.responseText);
			}
		});
	}


	// Get customer info on every page load
	$scope.getCustomer();
}]);

BOXFOX.controller('CustomCollateralController',
	['$scope', '$window', '$timeout', 'NotificationService', 'CustomCollateralData',
	function($scope, $window, $timeout, NotificationService, CustomCollateralData) {

		$scope.data = CustomCollateralData;

		console.log('CustomCollateralController: $scope.data');
		console.log($scope.data);

		$scope.previous_product_id = null;
		$scope.previous_image_url = null;
		$scope.use_previous_image = false;

		$scope.elements = {
			input: $('#preview-input'),
			clear: $('#preview-clear'),
			previous_image_url: $('#previous-image-url'),
			container_form_inputs: $('#container-preview-widget'),
			container_product_image: $('#container-product-image'),
			container_preview_image: $('#container-preview-image'),
			preview_label: $('#preview-label'),
			preview_image: $('#preview-image'),
		}

		$scope.minimums = {
			width: 0,
			height: 0
		}

		$scope.showPreviousImage = function() {
			console.log('showPreviousImage called');
			$scope.elements.preview_image.attr('src', $scope.previous_image_url);

			$scope.elements.container_product_image.hide();
			$scope.elements.container_preview_image.show();
		}

		$scope.showPreviewImage = function(file, data) {
			console.log('showPreviewImage called');
			$scope.elements.preview_label.html(file.name);
			$scope.elements.preview_image.attr('src', data);

			$scope.elements.container_form_inputs.addClass('has-file');
			$scope.elements.container_product_image.hide();
			$scope.elements.container_preview_image.show();
		}

		$scope.hidePreviewImage = function() {
			console.log('hidePreviewImage called');

			$scope.elements.preview_label.html($scope.elements.preview_label.data('default-label'));
			$scope.elements.preview_image.attr('src', '');

			$scope.elements.container_form_inputs.removeClass('has-file');
			$scope.elements.container_product_image.show();
			$scope.elements.container_preview_image.hide();
		}

		$scope.clearFile = function(event) {
			$scope.elements.input[0].value = '';
			$scope.elements.input.triggerHandler('change');

			$scope.hidePreviewImage();

			if (typeof event != 'undefined') {
				event.preventDefault();
			}
		}

		$scope.fileChange = function(event) {
			if (event.target.files && event.target.files[0]) {
				var reader, file;

				reader = new FileReader();
				file = event.target.files[0];

				reader.addEventListener('loadstart', function() {
					console.log('File reading started.');
				});

				reader.addEventListener('load', function(e) {
					$scope.validateImage(file, e.target.result);
				});

				reader.addEventListener('error', function() {
					alert('Error : Failed to read file');
				});

				console.log('===FILE===');
				console.log(file);

				$scope.elements.preview_label.html(file.name);
				reader.readAsDataURL(file);
			}
		}

		$scope.validateImage = function(file, data) {
			console.log('===FILE LOADED===');
			console.log(file);

			var i = new Image();

			i.onload = function(){
				console.log('IMAGE WIDTH:', i.width);
				console.log('IMAGE HEIGHT:', i.height);

				if (i.width < $scope.minimums.width) {
					alert('Please upload an image that is at least ' + minimums.width + 'px wide.');
				} else if (i.height < $scope.minimums.height) {
					alert('Please upload an image that is at least ' + minimums.height + 'px tall.');
				} else {
					$scope.showPreviewImage(file, data);
				}
			};

			i.src = data;
		}

		$scope.togglePreviousImage = function() {
			if ($scope.use_previous_image) {
				$scope.showPreviousImage();
			} else {
				$scope.hidePreviewImage();
			}
		}

		$scope.previousProductURL = function() {
			var url;

			if ($scope.previous_product_id) {
				url = 'https://boxfox-concierge.myshopify.com/admin/products/' + $scope.previous_product_id;
			}

			return url;
		}

		$scope.previousImageURL = function() {
			var url;

			if ($scope.previous_image_url) {
				url = $scope.previous_image_url;
			}

			return url;
		}

		$scope.validateCollateral = function() {
			var invalid = true;

			if ($scope.use_previous_image && $scope.previous_product_id && $scope.previous_image_url) {
				invalid = false;
			} else if ($scope.file) {
				invalid = false;
			}

			if (invalid) {
				return invalid;
			}
		}

		$scope.init = function() {
			$scope.previous_product_id = BOXFOX.helpers.getParameter('product_id');
			$scope.previous_image_url = BOXFOX.helpers.getParameter('image_url');

			if ($scope.previous_image_url) {
				$scope.use_previous_image = true;
			}

	    if ($scope.elements.input.attr('data-min-width').length) {
	      $scope.minimums.width = parseInt($scope.elements.input.attr('data-min-width'));
	    }

	    if ($scope.elements.input.attr('data-min-height').length) {
	      $scope.minimums.height = parseInt($scope.elements.input.attr('data-min-height'));
	    }

	    $scope.elements.input.bind('change', $scope.fileChange);
	    $scope.elements.clear.bind('click', $scope.clearFile);
			$scope.elements.previous_image_url.bind('change', $scope.togglePreviousImage).trigger('change');
		}

	}]);

BOXFOX.controller('ProposalController',
	['$rootScope', '$scope', '$element', '$compile', '$sce', '$window', '$timeout', '$http', 'NotificationService',
	function($rootScope, $scope, $element, $compile, $sce, $window, $timeout, $http, NotificationService) {
		$scope.initialized = false;

		$scope.proposals = [];
		$scope.selected_proposal = null;

		$scope.formData = {};

		$scope.budget = 5000;

		$scope.elements = {
			'list': $('#proposal-list'),
			'form': $('#proposal-form'),
			'results': $('#proposal-list-results'),
			'buttons': $('button[data-action]')
		}

		$scope.formattedBudget = function() {
			return '$' + ($scope.budget).formatMoney(0);
		}

		$scope.newProposal = function() {
			$scope.elements.list.hide();
			$scope.elements.form.show();
		}

		$scope.cancelProposal = function() {
			$scope.elements.list.show();
			$scope.elements.form.hide();

			$scope.elements.form[0].reset();
		}

		$scope.submitProposal = function() {
			console.log('submitting....');

			$.ajax({
				method: 'post',
				url: $scope.elements.form.attr('action'),
				data: $scope.elements.form.serialize(),
				cache: false,
				dataType: 'json',
				crossDomain: true,
				success: function(response) {
					console.log(response);

					$scope.customer.proposals.push(response);
					$scope.$apply();

					// Clear and hide form
					$scope.cancelProposal();
				},
				error: function(error) {
					console.log(error.responseText);
				}
			});
		}

		$scope.showProposal = function(proposal) {
			$scope.selected_proposal = proposal;

			$scope.elements.list.hide();
		}

		$scope.hideProposal = function() {
			$scope.selected_proposal = null;

			$scope.elements.list.show();
		}
	}]);

BOXFOX.controller('CartController',
	['$rootScope', '$scope', '$element', '$compile', '$sce', '$window', '$timeout', 'NotificationService',
	function($rootScope, $scope, $element, $compile, $sce, $window, $timeout, NotificationService) {
		$scope.cart = $window.cart_json;

		console.log('$scope.cart');
		console.log($scope.cart);

		$scope.add_recipients_method = null;

		$scope.current_address = null;

		$scope.handle = function(str) {
			return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
		}

		$scope.arraysContainsMatch = function(a, b) {
			var matches = false;
			for (var i = 0; i < b.length; i++) {
				if (a.indexOf(b[i]) > -1) {
					matches = true;
					break;
				}
			}
		}

		$scope.resetItemProperties = function(item) {
			item = item || $scope.product;

			// Set shipping object with defaults
			item.shipping = {
				method: null,
				quantity: 0,
				addresses: []
			};

			// Extend item with customer collateral
			item.collateral = [];

			// Override shipping object with properties
			if (item.properties) {
				// Shipping method: multi or bulk
				if (item.properties._shipping) {
					item.shipping.method = item.properties._shipping;
				}

				// Shipping quantity
				if (item.properties._quantity) {

					// Force the property to be an integer
					item.properties._quantity = parseInt(item.properties._quantity);

					item.shipping.quantity = item.properties._quantity;
				}

				// Shipping addresses
				if (item.properties._addresses) {
					var addresses = item.properties._addresses.split('|');

					for (var i = 0; i < addresses.length; i++) {
						item.shipping.addresses.push(JSON.parse(addresses[i]));
					}

					console.log('item.shipping.addresses');
					console.log(item.shipping.addresses);
				}

				// Customer collateral
				if (item.properties._collateral) {
					var collateral = item.properties._collateral.split('|');

					for (var i = 0; i < collateral.length; i++) {
						item.collateral.push(JSON.parse(collateral[i]));
					}

					console.log('item.collateral');
					console.log(item.collateral);
				}
			}

			console.log('reset item...');

			console.log(item);
		}

		$scope.addRecipients = function(index) {
			var template, html;

			// Set the selected product
			$scope.product = $scope.cart.items[index];

			// Populate a template
			template = $('#multi-ship-add-recipients-method').html();
			html = $compile(template)($scope);

			// Display modal
			NotificationService.miniPage({
				controller: {
					html: html,
					target: '.modal-dialog-content'
				}
			});
		}

		$scope.editRecipients = function(index) {
			var template, html;

			// Set the selected product
			$scope.product = $scope.cart.items[index];

			// Populate a template
			template = $('#multi-ship-add-recipients-' + $scope.product.properties['_shipping']).html();
			html = $compile(template)($scope);

			// Display modal
			NotificationService.miniPage({
				controller: {
					html: html,
					target: '.modal-dialog-content'
				}
			});
		}

		$scope.hasRecipients = function(index) {
			var properties = $scope.cart.items[index].properties;

			if (properties) {

				// If bulk is selected and a quantity is defined
				if (properties['_shipping'] == 'bulk' && properties['_quantity'] > 0) {
					return true;
				}

				// If multi is selected and an address is defined
				if (properties['_shipping'] == 'multi' && properties['_addresses']) {
					return true;
				}

			}


			// Return false if applicable
			return false;
		}

		$scope.recipientCount = function(index) {
			var quantity, properties;

			quantity = 0;
			properties = $scope.cart.items[index].properties;

			if (properties && properties._quantity) {
				quantity = parseInt(properties._quantity);
			}

			return quantity;
		}

		$scope.getCart = function() {
			$.getJSON("/cart.js", function(cart) {
				window.cart_json = cart;
			});
		}

		$scope.changeItem = function(data) {
			console.log('- - - data - - -');
			console.log(data);

			var params = {
				type: 'POST',
				url: '/cart/change.js',
				data: data,
				dataType: 'json',
				success: function(cart) {
					console.log('SUCCESS!!!');
					window.cart_json = cart;

					location.reload();
				},
				error: function(XMLHttpRequest, textStatus) {
					console.log('ERROR!!!');
				}
			};
			$.ajax(params);
		}

		$scope.selectRecipientMethod = function(method) {
			console.log('selectRecipientMethod');
			console.log(method);

			console.log('$scope.product');
			console.log($scope.product);

			// Remember the method
			$scope.product.shipping.method = method;

			var template, html;

			// Populate a template
			template = $('#multi-ship-add-recipients-' + $scope.product.shipping.method).html();
			html = $compile(template)($scope);

			// Hide previous modal
			NotificationService.hide();

			// Display modal
			NotificationService.miniPage({
				controller: {
					html: html,
					target: '.modal-dialog-content'
				}
			});
		}

		$scope.changeRecipientMethod = function() {
			// Reset the method
			$scope.product.shipping.method = null;

			// Hide previous modal
			NotificationService.hide();

			// Select a new method
			$scope.addRecipients($scope.product.index);
		}

		$scope.addRecipientsVia = function(method) {
			$scope.add_recipients_method = method;
		}

		$scope.saveRecipientChanges = function() {
			var properties = $scope.product.properties || {};
			properties['_shipping'] = $scope.product.shipping.method;
			properties['_quantity'] = $scope.product.shipping.quantity;

			// BULK: Remove addresses
			if ($scope.product.shipping.method == 'bulk') {
				delete properties['_addresses'];
				delete properties['_formatted_addresses'];
			}

			// Multi: Convert addresses to string and calculate quantity
			if ($scope.product.shipping.method == 'multi') {
				properties['_quantity'] = $scope.totalRecipientsFromAddresses();

				$scope.multipleAddressesAsProperties(properties, $scope.product.shipping.addresses);

				properties['_addresses'] = $scope.addressesToString($scope.product.shipping.addresses);
			}

			console.log(' - - - SAVING - - - ');

			console.log('$scope.product.shipping');
			console.log($scope.product.shipping);

			console.log('properties');
			console.log(properties);

			$scope.changeItem({
				line: ($scope.product.index + 1),
				quantity: $scope.product.shipping.quantity,
				properties: properties
			});

			// Hide modal
			NotificationService.hide();
		}

		$scope.cancelRecipientChanges = function() {
			$scope.resetItemProperties();
			NotificationService.hide();
		}

		$scope.uploadCSV = function() {
			var input, file;

			// Define input
			input = $('#csv-file')[0];

			// Validate input and parse results
			if (input.files && input.files[0]) {

				// Define file for convenience
				file = input.files[0];

				if (file.type == 'text/csv') {
					Papa.parse(input.files[0], {
						//header: true,
						skipEmptyLines: true,
						complete: function(results, file) {
							console.log('Parsing complete!');
							$scope.cleanAddresses(results.data);
							$('#csv-file').val('');
						},
						error: function(error, file) {
							console.log("Parsing ERROR:", results, file);
						}
					})
				} else {
					alert('Please upload a file in CSV format.')
				}
			}
		}

		$scope.cleanAddresses = function(addresses) {
			var required_fields = ['first_name', 'last_name', 'address1', 'city', 'province', 'zip', 'country'];

			// Clean and add address to array (if applicable)
			for (var i = 0, valid, address, clean_address; i < addresses.length; i++) {
				valid = true;

				address = addresses[i];

				clean_address = {
					first_name: '',
					last_name: '',
					company: '',
					address1: '',
					address2: '',
					city: '',
					province: '',
					zip: '',
					country: '',
					quantity: 1
				}

				// Populate clean_address
				for (var x = 0, field; x < address.length; x++) {
					field = address[x];

					// 0 - First Name
					// 1 - Last Name
					// 2 - Company
					// 3 - Address 1
					// 4 - Address 2
					// 5 - City
					// 6 - State
					// 7 - Zip Code
					// 8 - Country

					if (x === 0 && field.toLowerCase() != 'first name') {
						clean_address.first_name = field;
					}

					if (x === 1 && field.toLowerCase() != 'last name') {
						clean_address.last_name = field;
					}

					if (x === 2 && field.toLowerCase() != 'company') {
						clean_address.company = field;
					}

					if (x === 3 && field.toLowerCase() != 'address 1') {
						clean_address.address1 = field;
					}

					if (x === 4 && field.toLowerCase() != 'address 2') {
						clean_address.address2 = field;
					}

					if (x === 5 && field.toLowerCase() != 'city') {
						clean_address.city = field;
					}

					if (x === 6 && field.toLowerCase() != 'state') {
						clean_address.province = field;
					}

					if (x === 7 && field.toLowerCase() != 'zip code') {
						clean_address.zip = field;
					}

					if (x === 8 && field.toLowerCase() != 'country') {
						clean_address.country = field;
					}

				}

				// Validate clean_address
				for (var x = 0, field; x < required_fields.length; x++) {
					field = required_fields[x];

					if (clean_address[field] == '') {
						valid = false;
						break;
					}
				}

				if (valid) {
					$scope.product.shipping.addresses.push(clean_address);
				}
			}

			// Update total product quantity based on addresses
			$scope.totalRecipientsFromAddresses();

			console.log('- - - $scope.product.shipping - - - ');
			console.log($scope.product.shipping);

			// Go back to list view
			$scope.addRecipientsVia(null);

			// Update UI
			$scope.$apply();
		}

		$scope.clearRecipientAddresses = function() {
			$scope.product.shipping.addresses = [];
		}

		$scope.totalRecipientsFromAddresses = function() {
			var quantity = 0;

			for (var i = 0; i < $scope.product.shipping.addresses.length; i++) {
				quantity += $scope.product.shipping.addresses[i].quantity;
			}

			$scope.product.shipping.quantity = quantity;

			console.log('- - - $scope.product.shipping - - - ');
			console.log($scope.product.shipping);


			return quantity;
		}

		$scope.editAddress = function(address) {
			$scope.addRecipientsVia('manual');
			$scope.initAddress(address);
		}

		$scope.removeAddress = function(address) {
			for (var i = 0; i < $scope.product.shipping.addresses.length; i++) {
				if ($scope.product.shipping.addresses[i].$$hashKey == address.$$hashKey) {
					$scope.product.shipping.addresses.splice(i, 1);
					break;
				}
			}
		}

		$scope.addressesToString = function(addresses) {

			var address_strings = [];

			for (var i = 0; i < addresses.length; i++) {
				address_strings.push(JSON.stringify(addresses[i]));
			}

			return address_strings.join('|');
		}

		$scope.multipleAddressesAsProperties = function(properties, addresses) {
			var key, value;

			for (var i = 0, address; i < addresses.length; i++) {

				address = addresses[i];

				key = '_shipment_' + (i + 1);
				value = '';

				value += address.first_name + ' ' + address.last_name;

				if (address.company != null) {
					value += ', ';
					value += address.company;
				}

				value += ', ';
				value += address.address1;

				if (address.address2 != null) {
					value += ', ';
					value += address.address2;
				}

				value += ', ';
				value += address.city;

				value += ', ';
				value += address.province + ' ' + address.zip;

				value += ', ';
				value += address.country;

				value += '\n\n QUANTITY: ' + address.quantity;

				properties[key] = value;
			}

			return properties;
		}

		// *** *** *** ADDRESS (INDIVIDUAL) *** *** *** //
		// Countries
		$scope.all_countries = $window.Countries;
		$scope.available_countries = $.extend({}, $window.Countries);

		// Methods
		$scope.defaultAddress = function() {
			// Clear current address
			$scope.current_address = null;

			var address = {};

			address.first_name = null;
			address.last_name = null;
			address.company = null;
			address.address1 = null;
			address.address2 = null;
			address.city = null;
			address.province = null;
			address.country = null;
			address.zip = null;
			address.phone = null;
			address.province_code = null;
			address.country_code = null;
			address.country_name = null;
			address.selected_country = null;
			address.quantity = 1;

			$scope.address = address;

			// Default to US address
			$scope.setCountry('United States');

			return address;
		}

		$scope.initAddress = function(address) {
			// Initialize with provided address (if applicable)
			if (typeof address != 'undefined') {
				$scope.current_address = address;
				$scope.address = $.extend({}, address);

				console.log('init address with address');
				console.log($scope.address);
			} else {
				$scope.defaultAddress();
			}
		}

		$scope.setCountry = function(country) {
			country = country || $scope.address.country;

			if (country == null) {
				country = 'United States';
			}

			var selected_country, country_field, province_field, zip_field;

			selected_country = $scope.all_countries[country];
			country_field = $('[data-address-field="country"]');
			province_field = $('[data-address-field="province"]');
			zip_field = $('[data-address-field="zip"]');

			// Update form data (country)
			$scope.address.country = country;
			$scope.address.country_name = country;
			$scope.address.country_code = selected_country.code;
			$scope.address.selected_country = selected_country;

			// Update form data (province)
			if (selected_country.provinces != null) {
				$scope.setProvince(selected_country.provinces[0]);
			}

			// Update form field visibility
			country_field.removeClass('three-eights one-half');
			province_field.removeClass('three-eights one-half hidden');
			zip_field.removeClass('one-quarter one-half hidden');

			if (selected_country.provinces == null && selected_country.zip_required == false) {
				// Country Only
				province_field.addClass('hidden');
				zip_field.addClass('hidden');
			} else if (selected_country.provinces != null && selected_country.zip_required == false) {
				// Country & Province
				country_field.addClass('one-half');
				province_field.addClass('one-half');
				zip_field.addClass('hidden');
			} else if (selected_country.provinces == null && selected_country.zip_required == true) {
				// Country & Zip
				country_field.addClass('one-half');
				province_field.addClass('hidden');
				zip_field.addClass('one-half');
			} else if (selected_country.provinces != null && selected_country.zip_required == true) {
				// Country, Province, Zip
				country_field.addClass('three-eights');
				province_field.addClass('three-eights');
				zip_field.addClass('one-quarter');
			}

		}

		$scope.setProvince = function(province) {
			province = province || $scope.address.province;

			if (province == null) {
				province = $scope.address.selected_country.provinces[0];
			}

			// Update form data (province)
			$scope.address.province = province;
			$scope.address.province_code = $scope.address.selected_country.province_codes[province];
		}

		$scope.saveAddress = function() {
			var address = $.extend({}, $scope.address);

			console.log('- - - SAVING ADDRESS - - -');
			console.log(address);

			// Replace current address
			if ($scope.current_address) {
				for (var i = 0, current_address; i < $scope.product.shipping.addresses.length; i++) {
					current_address = $scope.product.shipping.addresses[i];
					if (current_address.$$hashKey == $scope.current_address.$$hashKey) {
						// Remove old address
						$scope.product.shipping.addresses.splice(i, 1);

						// Add new address
						$scope.product.shipping.addresses.splice(i, 0, address);

						// End
						break;
					}
				}
			} else {
				// Add new address to array
				$scope.product.shipping.addresses.push(address);
			}

			// Update total product quantity based on addresses
			$scope.totalRecipientsFromAddresses();

			console.log('- - - $scope.product.shipping - - - ');
			console.log($scope.product.shipping);

			// Reset address to default
			$scope.defaultAddress();

			// Go back to list view
			$scope.addRecipientsVia(null);
		}

		$scope.clearAddress = function() {
			console.log('- - - CANCEL ADDRESS - - -');

			$scope.defaultAddress();

			$scope.addRecipientsVia(null);
		}

		// *** *** *** COLLATERAL *** *** *** //
		$scope.hasNonCardAccountCollateral = function() {
			var has_collateral = false;

			for (var i = 0; i < $scope.customer.collateral.length; i++) {
				if ($scope.customer.collateral[i].type != 'Card') {
					has_collateral = true;
					break;
				}
			}

			return has_collateral;
		}

		$scope.hasAccountCollateralByType = function(type) {
			var has_collateral = false;

			type = type.toLowerCase();

			for (var i = 0; i < $scope.customer.collateral.length; i++) {
				if ($scope.customer.collateral[i].shopify_product.product_type.toLowerCase() == type) {
					has_collateral = true;
					break;
				}
			}

			return has_collateral;
		}

		$scope.collateralIsAvailable = function(collateral) {
			var available = true;

			if (collateral.shopify_product.variants[0].inventory_quantity <= 0) {
				available = false;
			}

			return available;
		}

		$scope.canAddCollateralToProduct = function(collateral) {
			var available = true;

			if ($scope.unavailableReasonInventory(collateral)) {
				available = false;
			} else if ($scope.unavailableReasonSize(collateral)) {
				available = false;
			} else if ($scope.unavailableReasonLogoTagApplied(collateral)) {
				available = false;
			} else if ($scope.unavailableReasonBellyBandApplied(collateral)) {
				available = false;
			} else if ($scope.unavailableReasonCollateralTypeApplied(collateral)) {
				available = false;
			}

			return available;
		}

		$scope.unavailableReasonInventory = function(collateral) {
			var available = true;

			if (!$scope.collateralIsAvailable(collateral)) {
				available = false;
			} else if (collateral.shopify_product.variants[0].inventory_quantity < $scope.product.quantity) {
				available = false;
			}

			return !available;
		}

		$scope.unavailableReasonSize = function(collateral) {
			var available = true;

			console.log('= = = = $scope.unavailableReasonSize: $scope.product = = = = = ');
			console.log($scope.product);

			var box_size = null;
			if ($scope.product.product_type == 'Dynamic Gift Box') {
				box_size = $scope.product.variant_options[1];
			} else if ($scope.product.product_tags.indexOf('Mini') != -1) {
				box_size = 'Mini';
			} else if ($scope.product.product_tags.indexOf('Regular') != -1) {
				box_size = 'Regular';
			} else if ($scope.product.product_tags.indexOf('Big') != -1) {
				box_size = 'Big';
			}

			var collateral_size = null;
			if (collateral.shopify_product.tags.indexOf('Mini') != -1) {
				collateral_size = 'Mini';
			} else if (collateral.shopify_product.tags.indexOf('Regular') != -1) {
				collateral_size = 'Regular';
			} else if (collateral.shopify_product.tags.indexOf('Big') != -1) {
				collateral_size = 'Big';
			}

			if (box_size && collateral_size && (box_size != collateral_size)) {
				available = false;
			}

			return !available;
		}

		$scope.unavailableReasonLogoTagApplied = function(collateral) {
			var available = true;

			if (collateral.shopify_product.product_type == 'Belly Band' && $scope.productHasCollateralByType('Logo Tag')) {
				available = false;
			}

			return !available;
		}

		$scope.unavailableReasonBellyBandApplied = function(collateral) {
			var available = true;

			if (collateral.shopify_product.product_type == 'Logo Tag' && $scope.productHasCollateralByType('Belly Band')) {
				available = false;
			}

			return !available;
		}

		$scope.unavailableReasonCollateralTypeApplied = function(collateral) {
			var available = true;

			if (!$scope.productHasCollateral(collateral) && $scope.productHasCollateralByType(collateral.shopify_product.product_type)) {
				available = false;
			}

			return !available;
		}

		$scope.cannotAddCollateralReason = function(collateral) {
			var reason;

			if ($scope.unavailableReasonInventory(collateral)) {
				reason = 'This item has insufficient inventory';
			} else if ($scope.unavailableReasonSize(collateral)) {
				reason = 'This item does not fit this box';
			} else if ($scope.unavailableReasonLogoTagApplied(collateral)) {
				reason = 'Logo Tag is already applied';
			} else if ($scope.unavailableReasonBellyBandApplied(collateral)) {
				reason = 'Belly Band is already applied';
			} else if ($scope.unavailableReasonCollateralTypeApplied(collateral)) {
				reason = 'This collateral type is already applied';
			}

			return reason;
		}

		$scope.getCollateralByProductID = function(shopify_product_id) {
			var obj = null;

			for (var i = 0; i < $scope.customer.collateral.length; i++) {
				if ($scope.customer.collateral[i].shopify_product_id == shopify_product_id) {
					obj = $scope.customer.collateral[i];
					break;
				}
			}

			return obj;
		}

		$scope.isCollateral = function(index) {
			var is_collateral, item, type, types;

			is_collateral = false;
			item = $scope.cart.items[index];
			type = item.product_type.toLowerCase();
			types = ['logo tag', 'card', 'bellyband', 'belly band', 'tissue sticker'];

			if (types.indexOf(type) != -1) {
				is_collateral = true;
			}

			return is_collateral;
		}

		$scope.addCollateral = function(index) {
			var template, html;

			// Set the selected product
			$scope.product = $scope.cart.items[index];

			// Add collateral array (if applicable)
			if (typeof $scope.product.collateral == 'undefined') {
				$scope.product.collateral = [];
			}

			console.log('- - - $scope.customer - - -');
			console.log($scope.customer);

			console.log('- - - $scope.product - - -');
			console.log($scope.product);

			// Populate a template
			template = $('#add-collateral-template').html();
			html = $compile(template)($scope);

			// Display modal
			NotificationService.miniPage({
				controller: {
					html: html,
					target: '.modal-dialog-content'
				}
			});
		}

		$scope.hasCollateral = function(index) {
			// Only return true if we have collateral other than a card
			var has_collateral, item;

			has_collateral = false;
			item = $scope.cart.items[index];

			if (item.collateral && item.collateral.length) {
				for (var i = 0; i < item.collateral.length; i++) {
					if (item.collateral[i].type != 'Card') {
						has_collateral = true;
					}

				}
			}

			return has_collateral;
		}

		$scope.collateralCount = function(index) {
			var quantity, item;

			quantity = 0;
			item = $scope.cart.items[index];

			if (item.collateral && item.collateral.length) {
				for (var i = 0; i < item.collateral.length; i++) {
					if (item.collateral[i].type != 'Card') {
						quantity += 1;
					}
				}
			}

			return quantity;
		}

		$scope.collateralReorderLink = function(collateral) {
			var url = '';
			var size_tags = ['Mini', 'Regular', 'Big'];

			url += '/collections/custom-collateral';
			url += '/products/' + $scope.handle(collateral.shopify_product.product_type);

			for (var i = 0; i < size_tags.length; i++) {
				if (collateral.shopify_product.tags.indexOf(size_tags[i]) > -1) {
					url += '-' + $scope.handle(size_tags[i]);
					break;
				}
			}

			url += '?product_id=' + collateral.shopify_product.id;

			if (collateral.shopify_product.image) {
				url += '&image_url=' + encodeURIComponent(collateral.shopify_product.image.src);
			}

			return url;
		}

		$scope.addCollateralToProduct = function(collateral) {
			$scope.product.collateral.push({
				shopify_product_id: collateral.shopify_product_id,
				type: collateral.type
			});
		}

		$scope.removeCollateralFromProduct = function(collateral) {
			console.log('removeCollateralFromProduct');
			for (var i = 0; i < $scope.product.collateral.length; i++) {
				if ($scope.product.collateral[i].shopify_product_id == collateral.shopify_product_id) {
					$scope.product.collateral.splice(i, 1);
					console.log('Item found and removed');
					break;
				}
			}

			console.log($scope.product.collateral);
		}

		$scope.productHasCollateral = function(collateral) {
			var has_collateral = false;

			for (var i = 0; i < $scope.product.collateral.length; i++) {
				if ($scope.product.collateral[i].shopify_product_id == collateral.shopify_product_id) {
					has_collateral = true;
					break;
				}
			}

			return has_collateral;
		}

		$scope.productHasCollateralByType = function(type) {
			var has_collateral = false;
			var collateral_types = ['Card', 'Logo Tag', 'Tissue Sticker', 'Belly Band'];

			if (collateral_types.indexOf(type) != -1) {
				for (var i = 0; i < $scope.product.collateral.length; i++) {
					if ($scope.product.collateral[i].type == type) {
						has_collateral = true;
						break;
					}
				}
			}

			return has_collateral;
		}

		$scope.toggleProductCollateral = function(collateral) {
			console.log('toggleProductCollateral', collateral.checked);

			if (collateral.checked) {
				$scope.addCollateralToProduct(collateral);
			} else {
				$scope.removeCollateralFromProduct(collateral);
			}
		}

		$scope.collateralToString = function(collateral) {

			var collateral_strings = [];

			for (var i = 0; i < collateral.length; i++) {
				collateral_strings.push(JSON.stringify(collateral[i]));
			}

			return collateral_strings.join('|');
		}

		$scope.addCollateralProperties = function(properties) {
			properties['_collateral'] = $scope.collateralToString($scope.product.collateral);

			// Contents
			properties['Collateral'] = '';
			for (var i = 0, collateral; i < $scope.product.collateral.length; i++) {
				collateral = $scope.getCollateralByProductID($scope.product.collateral[i].shopify_product_id);

				console.log('- - - COLLATERAL - - -');
				console.log(collateral);

				if (properties['Collateral'] != '') {
					properties['Collateral'] += ', \n';
				}

				properties['Collateral'] += collateral.shopify_product.title;
			}
		}

		$scope.saveCollateralChanges = function() {
			var properties = $scope.product.properties || {};

			if ($scope.product.collateral.length) {
				$scope.addCollateralProperties(properties);
			} else {
				delete properties['_collateral'];
				delete properties['Collateral'];
			}

			console.log(' - - - SAVING - - - ');


			console.log('properties');
			console.log(properties);

			$scope.changeItem({
				line: ($scope.product.index + 1),
				quantity: $scope.product.quantity,
				properties: properties
			});

			// Hide modal
			NotificationService.hide();
		}

		$scope.cancelCollateralChanges = function() {
			$scope.resetItemProperties();
			NotificationService.hide();
		}


		// *** *** *** EMAIL CONCIERGE *** *** *** //
		$scope.emailConcierge = function() {}


		// Update cart items with necessary data and properties
		for (var i = 0, item; i < $scope.cart.items.length; i++) {
			// Define item
			item = $scope.cart.items[i];

			// Set index
			item.index = i;

			// Set item to defaults
			$scope.resetItemProperties(item);
		}
	}]);
